<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">

					<div class="">
						<form id="FormPedido" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="row mt-2">
								<div class="col-12">
									<div class="card">
										<div class="card-body">
											<h5 class="card-title">Datos Generales</h5>

											<div class="row">
												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
													<BuscadorCliente 
														ref="buscadorCliente"
														:ptextLabel="'Buscar Cliente'"
														@input="getCliente()"
														v-model="objCliente.IdCliente">
														<CValidation v-if="this.errorvalidacion.IdCliente" :Mensaje="'*' + errorvalidacion.IdCliente[0]"/>
													</BuscadorCliente>
												</div>
												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
													<label class="form-label" for="ContactoCliente">Contacto</label>
													<input type="text" v-model="objCliente.Contacto" class="form-control" id="ContactoCliente" placeholder="" readonly />
												</div>

												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
													<label class="form-label" for="DireccionCliente">Dirección</label>
													<input type="text" v-model="objCliente.Direccion" class="form-control" id="DireccionCliente" placeholder="" readonly />
												</div>
											</div>

											<div class="row">
												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
													<label class="form-label" for="Rfc">RFC</label>
													<input type="text" v-model="objCliente.Rfc" class="form-control" id="Rfc" placeholder="" readonly />
												</div>

												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
													<label class="form-label" for="Paciente">Paciente</label>
													<input type="text" v-model="objPedido.Paciente" class="form-control" id="Paciente" placeholder="Ingresar Paciente" />
													<CValidation v-if="this.errorvalidacion.Paciente" :Mensaje="'*'+errorvalidacion.Paciente[0]"/>
												</div>
												
												<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"></div>
											</div>

										</div>
									</div>
								</div>
							</div>

							<div class="row mt-4">
								<div class="col-12">

									
									<div  class="card">
										<div class="card-body">

											<!-- PASO 1 -->
											<div v-if="showPasos.paso1">

												<h5 class="card-title">Seleccion de Lente</h5>

												<div class="row">
													<!-- SELECTOR DE TIPO DE LENTE (PROCESO) -->
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
														<h6>Tipo de Lente</h6>
														<!--<select v-model="objPedido.IdTipoLente" @change="selectorProceso()" class="form-control-search form-select" id="IdPerfil">
															<option :value="0">Seleccione una opción</option>
															<option v-for="(item, index) in ListaTipoLentes" :key="index" :value="item.IdTipoLente">{{item.Nombre}}</option>
														</select> -->
														<div class="row">
															<div v-show="parseInt(objPedido.IdCliente) != 0" class="col-auto" v-for="(item2,idextplente2) in ListaTipoLentes" :key="idextplente2">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.IdTipoLente" @change="selectorProceso()" class="form-check-input" type="radio" role="switch" :value="item2.IdTipoLente" :id="'idswitchplente'+item2.IdTipoLente" >
																	<label class="form-check-label" for="flexSwitchCheckDefault">{{ item2.Nombre }}</label>
																</div>
															</div>
															<div v-show="parseInt(objPedido.IdCliente) == 0" class="col-auto">
																<div class="alert alert-info" role="alert">
																	Necesita seleccionar un cliente para continuar.
																</div>
															</div>
														</div>
														
														<CValidation v-if="this.errorvalidacion.IdTipoLente" :Mensaje="'*'+errorvalidacion.IdTipoLente[0]"/>
													</div>
												</div>
												<div class="row mt-4">
													<!-- SELECTOR DE NUMERO DE PARES - PROCESO TIPO 2 -->
													<div v-if="showNumParesLentes" class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mt-2">
														<h6>Cantidad de Pares de Lentes</h6>
														<!-- <select v-model="objPedido.NumPar" class="form-control-search form-select" id="NumPar">
															<option :value="0">Seleccione una opción</option>
															<option :value="1">Un Par (1)</option>
															<option :value="2">Mas de un Par (2 o más)</option>
														</select> -->
														<div class="row">
															<div class="col-auto">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.NumPar"  class="form-check-input" type="radio" role="switch" :value="1" id="idswitchNumPares1" >
																	<label class="form-check-label" for="idswitchNumPares1">Un Par (1)</label>
																</div>
															</div>
															<div class="col-auto">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.NumPar"  class="form-check-input" type="radio" role="switch" :value="2" id="idswitchNumPares2" >
																	<label class="form-check-label" for="idswitchNumPares2">Mas de un Par (2 o más)</label>
																</div>
															</div>
														</div>
														
														<CValidation v-if="this.errorvalidacion.NumPar" :Mensaje="'*'+errorvalidacion.NumPar[0]"/>

													</div>
												</div>

												<!---- CONFIGRACION DE VALORES PARA LENTES ---->
												<template v-if="parseInt(objPedido.IdTipoLente) > 0 && showRXLentes">
													
													<!---- OJO LADO DERECHO ---->
													<div class="row mt-4">
														<h6>Medidas RX</h6>
														<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
															<div class="form-check form-switch">
																<input v-model="objPedido.OjoDerecho" @change="limpiaRXDerecho()" class="form-check-input" type="checkbox" role="switch" id="OjoDerecho">
																<label class="form-check-label" for="OjoDerecho">RX Ojo Derecho</label>
															</div>
														</div>
													</div>

													<div v-if="objPedido.OjoDerecho" class="row mt-1">

														<!-- ESFERA DERECHA -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdEsfera">Esfera</label>
															<input type="text" v-model="objPedido.OdEsfera" @input="$numberosPermitidos($event,objPedido,'OdEsfera'), accionInput('OdEsfera','Esfera')"
																:style="EsferaDerecha.showTool ? 'border-color:red;' :''"
																class="form-control" id="OdEsfera"/>

															<b-tooltip id="tooltip_OdEsfera" :show.sync="EsferaDerecha.showTool" target="OdEsfera" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

															<b-popover id="popover_OdEsfera" :disabled="true" custom-class="IzEsferas" :show.sync="EsferaDerecha.showPopOver" target="OdEsfera" ref="popOdEsfera" placement="top" @hidden="onHidden()">
																<template #title>
																	<b-button @click="onClose('OdEsfera','Esfera')" class="close c-pop" aria-label="Close">
																		<i class="fas fa-times text-black"></i>
																	</b-button>
																	Selecciona una Graduación
																</template>

																<span >
																	<div class="row" id="OdEsferaPopContener">
																		<div v-for="(item1,index1) in EsferaDerecha.listaMedidas" :key="index1+'_OdEf'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																			<button @click="setValor(item1.Valor,'Esfera','OdEsfera')" type="button" class="btn btn-primary" :id="index1+'_btnOdEf'"
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item1.Valor }}</button>
																		</div>	
																	</div>
																</span>

															</b-popover>
		
														</div>

														<!-- CILINDRO DERECHO -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdCilindro">Cilindro</label>
															<input type="text" v-model="objPedido.OdCilindro" @input="$numberosPermitidos($event,objPedido,'OdCilindro'), accionInput('OdCilindro','Cilindro')"
																:style="CilindroDerecho.showTool ? 'border-color:red;' :''" 
																class="form-control" id="OdCilindro"/>


															<b-tooltip id="tooltip_OdCilindro" :show.sync="CilindroDerecho.showTool" target="OdCilindro" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

															<b-popover :disabled="true" :show.sync="CilindroDerecho.showPopOver" target="OdCilindro" ref="popOdCilindro" placement="top" @hidden="onHidden()">
																<template #title>
																	<b-button type="button" @click="onClose('OdCilindro','Cilindro')" class="close c-pop" aria-label="Close">
																		<i class="fas fa-times text-black"></i>
																	</b-button>
																	Selecciona una Graduación
																</template>

																<span >
																	<div class="row" id="OdCilindroPopContener">
																		<div v-for="(item2,index2) in CilindroDerecho.listaMedidas" :key="index2+'_OdCl'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																			<button @click="setValor(item2.Valor,'Cilindro','OdCilindro')" type="button" class="btn btn-primary" :id="index2+'OdCl'"
																			style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item2.Valor }}</button>
																		</div>	
																	</div>
																</span>

															</b-popover> 
															
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdEje">Eje</label>
															<input @input="$onlyNums($event,objPedido,'OdEje'), validaRangosRX('Eje','OdEje')" type="text" v-model="objPedido.OdEje" class="form-control" id="OdEje"
															:style="toolTipRX.showToolOdEje || toolTipRX.showToolOdEjeRequire ? 'border-color:red;' :''" 
															:readonly="CilindroDerecho.blockEje"/>
															<center><label id="lblodeje">0 - 180</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEje" target="OdEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdEjeRequire" target="OdEje" placement="top"> Campo Obligatorio</b-tooltip>
														</div>

														<!-- RANGO ADICIONAL DERECHA -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdAdicion">*Adición</label>
															<input type="text" v-model="objPedido.OdAdicion" @input="$numberosPermitidos($event,objPedido,'OdAdicion'), accionInput('OdAdicion','RangoAdicional')"
																:style="RanAdicionalDerecho.showTool ? 'border-color:red;' :''"
																class="form-control" id="OdAdicion" :readonly="TpLenteSelect.Adicion == 'NO'"/>

																<b-tooltip id="tooltip_OdAdicion" :show.sync="RanAdicionalDerecho.showTool" target="OdAdicion" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>
																<b-popover id="popover_OdAdicion" :disabled="true"  :show.sync="RanAdicionalDerecho.showPopOver" target="OdAdicion" ref="popOdAdicion" placement="top" @hidden="onHidden()">
																	<template #title>
																		<button type="button" @click="onClose('OdAdicion','RangoAdicional')" class="close c-pop" aria-label="Close">
																			<i class="fas fa-times text-black"></i>
																		</button>
																		Selecciona una Graduación
																	</template>

																	<span >
																		<div class="row" id="OdAdicionPopContener">
																			<div v-for="(item3,index3) in RanAdicionalDerecho.listaMedidas" :key="index3+'_OdRg'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																				<button @click="setValor(item3.Valor,'RangoAdicional','OdAdicion')" type="button" class="btn btn-primary" :id="index3+'_btnOdRg'"
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item3.Valor }}</button>
																			</div>	
																		</div>
																	</span>

																</b-popover>
															
															
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdAltMon">*Alt. Mon</label>
															<input @input="$onlyNums($event,objPedido,'OdAltMon')" @change="validaRangosRX('AltMont','OdAltMon')" type="text" v-model="objPedido.OdAltMon" :style="toolTipRX.showToolOdAltMon ? 'border-color:red;' :''" 
																class="form-control" id="OdAltMon" :readonly="TpLenteSelect.AltMon == 'NO'" />
															<center><label id="lblodaltmon">{{TpLenteSelect.ValMinMon}} - {{ TpLenteSelect.ValMaxMon }}</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdAltMon" target="OdAltMon" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinMon}} a {{ TpLenteSelect.ValMaxMon }}</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdAltSeg">Alt. Seg.</label>
															<input  @input="$onlyNums($event,objPedido,'OdAltSeg')" @change="validaRangosRX('AltSeg','OdAltSeg')" type="text" v-model="objPedido.OdAltSeg" :style="toolTipRX.showToolOdAltSeg ? 'border-color:red;' :''" 
																class="form-control" id="OdAltSeg" :readonly="TpLenteSelect.AltSeg == 'NO'" />
															<center><label id="lblodaltseg">{{TpLenteSelect.ValMinSeg}} - {{ TpLenteSelect.ValMaxSeg }}</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdAltSeg" target="OdAltSeg" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinSeg}} a {{ TpLenteSelect.ValMaxSeg }}</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdDnp">*DNP</label>
															<input @input="$onlyNums($event,objPedido,'OdDnp')" @change="validaRangosRX('Dnp','OdDnp')" type="text" v-model="objPedido.OdDnp" :style="toolTipRX.showToolOdDnp ? 'border-color:red;' :''" 
																class="form-control" id="OdDnp" />
															<center><label id="lbloddnp">20 - 50</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdDnp" target="OdDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OdPrisma">Prisma</label>
															<input @input="$onlyNums($event,objPedido,'OdPrisma'), validaRangosRX('Prisma','OdPrisma')" type="text" v-model="objPedido.OdPrisma" :style="toolTipRX.showToolOdPrisma ? 'border-color:red;' :''" 
																class="form-control" id="OdPrisma" />
															<center><label id="lblodprisma">0 - 15</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOdPrisma" target="OdPrisma" placement="top"> Rango unicamente de 0 a 15</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-2">
															<label class="form-label" for="OdPosicion">Posición</label>
															<select v-model="objPedido.OdPosicion" class="form-control-search form-select" id="OdPosicion">
																<option value="">Seleccione una opción</option>
																<option v-for="(item, index) in ListPosicionesLentes" :key="index" :value="item.id">{{item.label}}</option>
															</select>
															<CValidation v-if="this.errorvalidacion.OdPosicion" :Mensaje="'*'+errorvalidacion.OdPosicion[0]"/>
														</div>
													</div>
												
												
													<!---- OJO LADO IZQUIERDO ---->
													<div class="row mt-4">
														<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
															<div class="form-check form-switch">
																<input v-model="objPedido.OjoIzquierdo" @change="limpiaRXIzquierdo()" class="form-check-input" type="checkbox" role="switch" id="OjoIzquierdo">
																<label class="form-check-label" for="OjoIzquierdo">RX Ojo Izquierdo</label>
															</div>
														</div>
													</div>


													<div v-if="objPedido.OjoIzquierdo" class="row mt-1">
														<!-- ESFERA IZQUIERDA -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiEsfera">Esfera</label>
															<input type="text" v-model="objPedido.OiEsfera" @input="$numberosPermitidos($event,objPedido,'OiEsfera'), accionInput('OiEsfera','Esfera')"
																:style="EsferaIzquierda.showTool ? 'border-color:red;' :''"
																class="form-control" id="OiEsfera"/>

															<b-tooltip id="tooltip_OiEsfera" :show.sync="EsferaIzquierda.showTool" target="OiEsfera" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

															<b-popover id="popover_OiEsfera" :disabled="true" custom-class="IzEsferas" :show.sync="EsferaIzquierda.showPopOver" target="OiEsfera" ref="popOiEsfera" placement="top" @hidden="onHidden()">
																<template #title>
																	<b-button @click="onClose('OiEsfera','Esfera')" class="close c-pop" aria-label="Close">
																		<i class="fas fa-times text-black"></i>
																	</b-button>
																	Selecciona una Graduación
																</template>

																<span >
																	<div class="row" id="OiEsferaPopContener">
																		<div v-for="(item4,index4) in EsferaIzquierda.listaMedidas" :key="index4+'_OiEf'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																			<button @click="setValor(item4.Valor,'Esfera','OiEsfera')" type="button" class="btn btn-primary" :id="index4+'_btnOiEf'"
																			style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item4.Valor }}</button>
																		</div>	
																	</div>
																</span>

															</b-popover>
														</div>

														<!-- CILINDRO IZQUIERDO -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiCilindro">Cilindro</label>
															<input type="text" v-model="objPedido.OiCilindro" @input="$numberosPermitidos($event,objPedido,'OiCilindro'), accionInput('OiCilindro','Cilindro')"
																:style="CilindroIzquierdo.showTool ? 'border-color:red;' :''" 
																class="form-control" id="OiCilindro"/>
															
															<b-tooltip id="tooltip_OiCilindro" :show.sync="CilindroIzquierdo.showTool" target="OiCilindro" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

															<b-popover :disabled="true"  :show.sync="CilindroIzquierdo.showPopOver" target="OiCilindro" ref="popOiCilindro" placement="top" @hidden="onHidden()">
																<template #title>
																	<b-button @click="onClose('OiCilindro','Cilindro')" class="close c-pop" aria-label="Close">
																		<i class="fas fa-times text-black"></i>
																	</b-button>
																	Selecciona una Graduación
																</template>

																<span >
																	<div class="row" id="OiCilindroPopContener">
																		<div v-for="(item5,index) in CilindroIzquierdo.listaMedidas" :key="index+'_OiCl'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																			<button  @click="setValor(item5.Valor,'Cilindro','OiCilindro')"  type="button" class="btn btn-primary" 
																				style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item5.Valor }}</button>
																		</div>	
																	</div>
																</span>

															</b-popover> 
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiEje">Eje</label>
															<input @input="$onlyNums($event,objPedido,'OiEje'), validaRangosRX('Eje','OiEje')" type="text" v-model="objPedido.OiEje" class="form-control" id="OiEje"
															:style="toolTipRX.showToolOiEje || toolTipRX.showToolOiEjeRequire ? 'border-color:red;' :''" 
															:readonly="CilindroIzquierdo.blockEje" />
															<center><label id="lblodeje">0 - 180</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEje" target="OiEje" placement="top"> Rango unicamente de 0 a 180</b-tooltip>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiEjeRequire" target="OiEje" placement="top"> Campo Obligatorio</b-tooltip>
														</div>

														<!-- RANGO ADICIONAL IZQUIERDA -->
														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="Adicion">*Adición</label>
															<input type="text" v-model="objPedido.OiAdicion" @input="$numberosPermitidos($event,objPedido,'OiAdicion'), accionInput('OiAdicion','RangoAdicional')"
																:style="toolTipRX.showTool ? 'border-color:red;' :''"
																class="form-control" id="OiAdicion" :readonly="TpLenteSelect.Adicion == 'NO'"/>

															<b-tooltip id="tooltip_OiAdicion" :show.sync="RanAdicionalIzquierdo.showTool" target="OiAdicion" placement="top"> Indique valores <strong>(+/-)</strong> </b-tooltip>

															<b-popover id="popover_OiAdicion"  :disabled="true"  :show.sync="RanAdicionalIzquierdo.showPopOver" target="OiAdicion" ref="popOiAdicion" placement="top" @hidden="onHidden()">
																<template #title>
																	<b-button @click="onClose('OiAdicion','RangoAdicional')" class="close c-pop" aria-label="Close">
																		<i class="fas fa-times text-black"></i>
																	</b-button>
																	Selecciona una Graduación
																</template>

																<span >
																	<div class="row" id="OiAdicionPopContener">
																		<div v-for="(item6,index6) in RanAdicionalIzquierdo.listaMedidas" :key="index6+'_OiRg'" class="col-3 col-sm-3 col-md-3 col-lg-3">
																			<button @click="setValor(item6.Valor,'RangoAdicional','OiAdicion')"  type="button" class="btn btn-primary" :id="index6+'_btnOiRg'"
																			style="--bs-btn-padding-y: .35rem; --bs-btn-padding-x: .10rem; --bs-btn-font-size: .75rem; width:50px;">{{ item6.Valor }}</button>
																		</div>	
																	</div>
																</span>

															</b-popover>

														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiAltMon">*Alt. Mon</label>
															<input @input="$onlyNums($event,objPedido,'OiAltMon')" @change="validaRangosRX('AltMont','OiAltMon')" :style="toolTipRX.showToolOiAltMon ? 'border-color:red;' :''" type="text" v-model="objPedido.OiAltMon" 
															class="form-control" id="OiAltMon" :readonly="TpLenteSelect.AltMon == 'NO'" />

															<center><label id="lblodaltmon">{{TpLenteSelect.ValMinMon}} - {{ TpLenteSelect.ValMaxMon }}</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiAltMon" target="OiAltMon" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinMon}} a {{ TpLenteSelect.ValMaxMon }}</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiAltSeg">Alt. Seg.</label>
															<input @input="$onlyNums($event,objPedido,'OiAltSeg')" @change="validaRangosRX('AltSeg','OiAltSeg')" :style="toolTipRX.showToolOiAltSeg ? 'border-color:red;' :''" type="text" v-model="objPedido.OiAltSeg" 
																class="form-control" id="OiAltSeg" :readonly="TpLenteSelect.AltSeg == 'NO'" />

															<center><label id="lblodaltseg">{{TpLenteSelect.ValMinSeg}} - {{ TpLenteSelect.ValMaxSeg }}</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiAltSeg" target="OiAltSeg" placement="top"> Rango unicamente de {{TpLenteSelect.ValMinSeg}} a {{ TpLenteSelect.ValMaxSeg }}</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiDnp">*DNP</label>
															<input @input="$onlyNums($event,objPedido,'OiDnp')" @change="validaRangosRX('Dnp','OiDnp')" :style="toolTipRX.showToolOiDnp ? 'border-color:red;' :''" type="text" v-model="objPedido.OiDnp" 
															class="form-control" id="OiDnp" />

															<center><label id="lbloddnp">20 - 50</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiDnp" target="OiDnp" placement="top"> Rango unicamente de 20 a 50</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1">
															<label class="form-label" for="OiPrisma">Prisma</label>
															<input @input="$onlyNums($event,objPedido,'OiPrisma'), validaRangosRX('Prisma','OiPrisma')" :style="toolTipRX.showToolOiPrisma ? 'border-color:red;' :''" type="text" v-model="objPedido.OiPrisma" 
															class="form-control" id="OiPrisma" />

															<center><label id="lblodprisma">0 - 15</label></center>
															<b-tooltip :disabled="true" :show.sync="toolTipRX.showToolOiPrisma" target="OiPrisma" placement="top"> Rango unicamente de 0 a 15</b-tooltip>
														</div>

														<div class="col-4 col-sm-4 col-md-4 col-lg-1 col-xl-2">
															<label class="form-label" for="OdPosicion">Posición</label>
															<select v-model="objPedido.OiPosicion" class="form-control-search form-select" id="OdPosicion">
																<option value="">Seleccione una opción</option>
																<option v-for="(item, index) in ListPosicionesLentes" :key="index" :value="item.id">{{item.label}}</option>
															</select>
															<CValidation v-if="this.errorvalidacion.OdPosicion" :Mensaje="'*'+errorvalidacion.OdPosicion[0]"/>
														</div>
													</div>
												</template>
												<!---- TERMINA CONFIGRACION DE VALORES PARA LENTES ---->

												<div v-show="this.objPedido.IdTipoLente > 0" class="row">
													<div class="col-6"></div>
													<div class="col-6 text-end">
														<button @click="cambiarPaso(2)" type="button" class="btn btn-primary">Siguiente</button>
													</div>
												</div>

											</div><!-- END PASO 1 -->
											
											<!-- PASO 2 -->
											<div v-if="showPasos.paso2">
												<h5 class="card-title">Configuración de Lente</h5>
												
												<!-- SELECTOR DE SUB-LINEA-->
												<div class="row">
													<div v-if="parseInt(TpLenteSelect.IdTipoLente) == 1" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

														<h6>* Sub-línea</h6>
														<!-- <select v-model="objPedido.IdSubLinea" @change="getArticulosWeb()" class="form-control-search form-select" id="IdSubLinea">
															<option :value="0">Seleccione una opción</option>
															<option v-for="(item, index) in ListaSublineas" :key="index" :value="item.IdSublinea">{{item.Nombre}}</option>
														</select> -->

														<div class="row">
															<div class="col-auto" v-for="(item3,idexsublinea2) in ListaSublineas" :key="idexsublinea2">
																<div class=" form-check-inline form-check form-switch form-sw">
																	<input v-model="objPedido.IdSubLinea" @change="getArticulosWeb()" class="form-check-input" type="radio" role="switch" :value="item3.IdSublinea" :id="'idswitchplente'+item3.IdSublinea" >
																	<label class="form-check-label" for="flexSwitchCheckDefault">{{ item3.Nombre }}</label>
																</div>
															</div>
														</div>
														<CValidation v-if="this.errorvalidacion.IdSubLinea" :Mensaje="'*'+errorvalidacion.IdSubLinea[0]"/>
													</div>
												</div>

												<!-- SELECTOR DE ARTICULO "WEB" -->
												<div class="row">
													<div v-show=" parseInt(TpLenteSelect.IdTipoLente) > 1 || objPedido.IdSubLinea > 0" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
														
														<div class="row">
															<div class="col-12">
																<h6><span class="text-red">*</span> Artículos</h6>
																<!-- <select v-model="objPedido.IdArticuloWeb" @change="getMateriales()" class="form-control-search form-select" id="IdArticuloWeb">
																	<option :value="0">Seleccione una opción</option>
																	<option v-for="(item, index) in ListaArticulosWeb" :key="index" :value="item.IdArticuloWeb">{{item.Nombre}}</option>
																</select> -->
																<div class="row">
																	<div class="col-auto" v-for="(item4,idexarticuloweb) in ListaArticulosWeb" :key="idexarticuloweb">
																		<div class=" form-check-inline form-check form-switch form-sw" :title="item4.RazonBloqueo" v-b-tooltip.hover>
																			<input v-model="objPedido.IdArticuloWeb" @change="getMateriales()" :disabled="item4.Seleccionable=='NO'"  class="form-check-input" 
																			type="radio" role="switch" :value="item4.IdArticuloWeb" :id="'idswitcharticulo'+item4.IdArticuloWeb" >
																			<label class="form-check-label"  for="idswitcharticulo">{{ item4.Nombre }}</label>
																		</div>
																	</div>
																</div>
																<CValidation v-if="this.errorvalidacion.IdArticuloWeb" :Mensaje="'*'+errorvalidacion.IdArticuloWeb[0]"/>
															</div>


														

														</div>
													
													</div>
												</div>

												<!-- PARAMETROS ADICIONALES DEL LENTE -->
												<div v-if="articuloWebSelect.ViewSeccion" class="row mt-4">
													
													<h6>* Parametros de personalización digital</h6>

													<!-- SELECTOR DE ARTICULO "WEB" -->
													<div v-if="articuloWebSelect.AnguloPantoscopico == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
														<label class="form-label" for="AnguloPantoscopico">* Ang. pantoscópico</label>
														<input @input="validaRangosRX('AngPantos')" type="text" v-model="objPedido.AnguloPantoscopico" class="form-control" id="AnguloPantoscopico"  />
														<center><label id="lblAnguloPantoscopico">0° a 20°</label></center>
														<CValidation v-if="this.errorvalidacion.AnguloPantoscopico" :Mensaje="'*'+errorvalidacion.AnguloPantoscopico[0]"/>

														<b-tooltip :disabled="true" id="tooltip_AnguloPantoscopico" :show.sync="toolTipRX.showToolAngPantos" target="AnguloPantoscopico" placement="top"> Introduce un valor entre 0° y 20° </b-tooltip>
													</div>

													<div v-if="articuloWebSelect.AnguloPanoramico == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
														<label class="form-label" for="AnguloPanoramico">*Ang. panorámico</label>
														<input @input="validaRangosRX('AngPanoram')" type="text" v-model="objPedido.AnguloPanoramico" class="form-control" id="AnguloPanoramico"  />
														<center><label id="lblAnguloPanoramico">0° a 20°</label></center>
														<CValidation v-if="this.errorvalidacion.AnguloPanoramico" :Mensaje="'*'+errorvalidacion.AnguloPanoramico[0]"/>

														<b-tooltip :disabled="true" id="tooltip_AnguloPanoramico" :show.sync="toolTipRX.showToolAngPanoram" target="AnguloPanoramico" placement="top"> Introduce un valor entre 0° y 20° </b-tooltip>
													</div>

													<div v-if="articuloWebSelect.DistanciaVertice == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
														<label class="form-label" for="DistanciaVertice">*Dist. al vertice (mm)</label>
														<input @input="validaRangosRX('DistVertice')" type="text" v-model="objPedido.DistanciaVertice" class="form-control" id="DistanciaVertice"  />
														<center><label id="lblDistanciaVertice">0 a 40 mm</label></center>
														<CValidation v-if="this.errorvalidacion.DistanciaVertice" :Mensaje="'*'+errorvalidacion.DistanciaVertice[0]"/>

														<b-tooltip :disabled="true" id="tooltip_DistanciaVertice" :show.sync="toolTipRX.showToolDistVertice" target="DistanciaVertice" placement="top"> Introduce un valor entre 0 y 40 </b-tooltip>
													</div>

													<div v-if="articuloWebSelect.DistanciaLectura == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
														<label class="form-label" for="DistanciaLectura">*Dist. de lectura (cm)</label>
														<input @input="validaRangosRX('DistLectura')" type="text" v-model="objPedido.DistanciaLectura" class="form-control" id="DistanciaLectura"  />
														<center><label id="lblDistanciaLectura">0 a 40 cm</label></center>
														<CValidation v-if="this.errorvalidacion.DistanciaLectura" :Mensaje="'*'+errorvalidacion.DistanciaLectura[0]"/>

														<b-tooltip :disabled="true" id="tooltip_DistanciaLectura" :show.sync="toolTipRX.showToolDistLectura" target="DistanciaLectura" placement="top"> Introduce un valor entre 0 y 40 </b-tooltip>
													</div>

													<div v-if="articuloWebSelect.Iniciales == 'SI' " class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
														<label class="form-label" for="Iniciales">* Iniciales</label>
														<input type="text" v-model="objPedido.Iniciales" class="form-control" id="Iniciales"  />
														<CValidation v-if="this.errorvalidacion.Iniciales" :Mensaje="'*'+errorvalidacion.Iniciales[0]"/>
													</div>

												</div>

												<!-- SELECTOR DE MATERIALES-->
												<div v-show="articuloWebSelect.IdArticuloWeb > 0  && articuloWebSelect.Seleccionable == 'SI'" class="row mt-4">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

														<div class="row">
															<div class="col-12">
																<h6>* Materiales</h6>
																<!-- <select v-model="objPedido.IdMaterial" @change="getValidMaterialSelected()" class="form-control-search form-select" id="IdMaterial">
																	<option :value="0">Seleccione una opción</option>
																	<option v-for="(item, index) in ListaMateriales" :key="index" :value="item.IdMaterial">{{item.Nombre}}</option>
																</select> -->

																<div class="row">
																	<div class="col-auto" v-for="(item5,idexmateriales) in ListaMateriales" :key="idexmateriales">
																		<div class=" form-check-inline form-check form-switch form-sw" :title="item5.RazonBloqueo" v-b-tooltip.hover>
																			<input v-model="objPedido.IdMaterial" @change="getValidMaterialSelected()" :disabled="item5.Seleccionable=='NO'"  class="form-check-input" 
																			type="radio" role="switch" :value="item5.IdMaterial" :id="'idswitchmaterial'+item5.IdMaterial" >
																			<label class="form-check-label"  for="idswitchmaterial">{{ item5.Nombre }}</label>
																		</div>
																	</div>
																</div>

																<CValidation v-if="this.errorvalidacion.IdMaterial" :Mensaje="'*'+errorvalidacion.IdMaterial[0]"/>
															</div>

															<!--- <div class="col-2">
																<div v-if="bndBloqueoMaterial">
																	<h6>
																		<i class="fad fa-info-circle fa-lg" id="razon-bloqueo-articulo" style="--fa-primary-color: #000000; --fa-secondary-color: #f5dc3d; --fa-secondary-opacity: 1; cursor: pointer; margin-top:2.75rem;"></i>
																	</h6>
																	<b-popover :show.sync="toolTipRX.showPopMaterial" target="razon-bloqueo-articulo" triggers="hover" placement="top">
																		<template #title>Articulo no disponible</template>
																		{{ materialSelect.RazonBloqueo }}
																	</b-popover>
																</div>
															</div> -->
														</div>
														
													</div>
												</div>

												<div v-show="!bndBloqueoProtxRecub" class="row mt-4">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
													
														<h6>* Protección</h6>
														<!-- <select v-model="objPedido.IdProteccion" @change="calculaCostosProtecciones()" class="form-control-search form-select" id="IdProteccion">
															<option :value="0">Seleccione una opción</option>
															<option v-for="(item5, index5) in ListaProtecciones" :key="index5" :value="item5.IdProteccion">{{item5.Nombre}}</option>
														</select>-->

														<div class="row">
															<div class="col-auto" v-for="(item6,idexprotecc) in ListaProtecciones" :key="idexprotecc">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item6.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdProteccion" @change="calculaCostosProtecciones()" :disabled="item6.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item6.IdProteccion" :id="'idswitchprotecc'+item6.IdProteccion" >
																	<label class="form-check-label"  for="idswitchprotecc">{{ item6.Nombre }}</label>
																</div>
															</div>
														</div>
														<CValidation v-if="this.errorvalidacion.IdProteccion" :Mensaje="'*'+errorvalidacion.IdProteccion[0]"/>
													</div>
												</div>

												<div v-show="parseInt(objPedido.IdMaterial) > 0" class="row mt-4">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
													
														<h6>* Recubrimiento</h6>
														<!--<select v-model="objPedido.IdRecubrimiento" @change="calculaCostosRecubrimiento()" class="form-control-search form-select" id="IdRecubrimiento">
															<option :value="0">Seleccione una opción</option>
															<option v-for="(item6, index6) in ListaRecubrimientos" :key="index6" :value="item6.IdRecubrimiento">{{item6.Nombre}}</option>
														</select> -->

														<div class="row">
															<div class="col-auto" v-for="(item7,idexrecubrimiento) in ListaRecubrimientos" :key="idexrecubrimiento">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item7.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdRecubrimiento" @change="calculaCostosRecubrimiento()" :disabled="item7.Seleccionable=='NO'"  class="form-check-input" 
																	type="radio" role="switch" :value="item7.IdRecubrimiento" :id="'idswitchrecubrimiento'+item7.IdRecubrimiento" >
																	<label class="form-check-label"  for="idswitchrecubrimiento">{{ item7.Nombre }}</label>
																</div>
															</div>
														</div>

														<CValidation v-if="this.errorvalidacion.IdRecubrimiento" :Mensaje="'*'+errorvalidacion.IdRecubrimiento[0]"/>
													</div>
												</div>

												<div v-show="this.objPedido.IdTipoLente > 0" class="row mt-4">
													<div class="col-6"></div>
													<div class="col-6 text-end">
														<button @click="cambiarPaso(1)" type="button" class="btn btn-secondary me-2">Anterior</button>
														<button @click="cambiarPaso(3)" type="button" class="btn btn-primary">Siguiente</button>
													</div>
												</div>

											</div><!-- END PASO 2 -->
											
											<!-- PASO 3 -->
											<div  v-if="showPasos.paso3" class="mt-5">
												<h5 class="card-title">Configuración de Armazón</h5>

												<div class="row mt-2">

													<div class="col-2">
														<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
														<div class="form-check form-switch">
															<input v-model="objPedido.EnviaArmazon" @change="setBiselesActivos()" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
															<label class="form-check-label" for="CambioForma">Envia Armazón</label>
														</div>
													</div>

													<template v-if="objPedido.EnviaArmazon">
														<div class="col-4">
															<h6>Estado del Armazón</h6>
															<div class="form-check form-check-inline">
																<input v-model="objPedido.EstadoArmazon" class="form-check-input" type="radio" name="EstadoArmazon" id="EstadoArmazon1" value="Nuevo">
																<label class="form-check-label" for="EstadoArmazon1">Nuevo</label>
															</div>
															<div class="form-check form-check-inline">
																<input v-model="objPedido.EstadoArmazon" class="form-check-input" type="radio" name="EstadoArmazon" id="EstadoArmazon2" value="Usado">
																<label class="form-check-label" for="EstadoArmazon2">Usado</label>
															</div>
															<CValidation v-if="this.errorvalidacion.EstadoArmazon" :Mensaje="'*'+errorvalidacion.EstadoArmazon[0]"/>
														</div>
														
														<div class="col-2">
															<label class="form-label" for="MarcaArmazon">*Marca</label>
															<input type="text" v-model="objPedido.MarcaArmazon" class="form-control" id="MarcaArmazon" placeholder="" />
															<CValidation v-if="this.errorvalidacion.MarcaArmazon" :Mensaje="'*'+errorvalidacion.MarcaArmazon[0]"/>
														</div>

														<div class="col-2">
															<label class="form-label" for="ModeloArmazon">*Modelo</label>
															<input type="text" v-model="objPedido.ModeloArmazon" class="form-control" id="ModeloArmazon" placeholder="" />
															<CValidation v-if="this.errorvalidacion.ModeloArmazon" :Mensaje="'*'+errorvalidacion.ModeloArmazon[0]"/>
														</div>

														<div class="col-2">
															<label class="form-label" for="ColorArmazon">*Color</label>
															<input type="text" v-model="objPedido.ColorArmazon" class="form-control" id="ColorArmazon" placeholder="" />
															<CValidation v-if="this.errorvalidacion.ColorArmazon" :Mensaje="'*'+errorvalidacion.ColorArmazon[0]"/>
														</div>
													</template>
							
												</div>
												<br>

												<div class="row">
													<div class="col-12">
														<h6><span class="text-red">*</span> Tipo de Armazón</h6>
														<!-- <select v-model="objPedido.IdArmazon" @change="setBiselesActivos()" class="form-control-search form-select" id="IdArticuloWeb">
															<option :value="0">Seleccione una opción</option>
															<option v-for="(item, index) in ListaArmazones" :key="index" :value="item.IdArmazon">{{item.Nombre}}</option>
														</select>-->
														<div class="row">
															<div class="col-auto" v-for="(item8,idexbisel) in ListaArmazones" :key="idexbisel">
																<div class=" form-check-inline form-check form-switch form-sw" :title="item8.RazonBloqueo" v-b-tooltip.hover>
																	<input v-model="objPedido.IdArmazon" @change="setBiselesActivos()" :disabled="item8.Seleccionable=='NO'" class="form-check-input" 
																	type="radio" role="switch" :value="item8.IdArmazon" :id="'idswitchbisel'+item8.IdArmazon" >
																	<label class="form-check-label"  for="idswitchbisel">{{ item8.Nombre }}</label>
																</div>
															</div>
														</div>

														<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
													</div>
												</div>

												<div class="row mt-4">
													<template v-if="objPedido.EnviaArmazon == true">
														<div class="col-3">
															<h6>Bisel</h6>
															<select v-model="objPedido.IdBisel" @change="getMateriales()" class="form-control-search form-select" id="IdBisel" disabled >
																<option :value="0">Seleccione una opción</option>
																<option v-for="(item, index) in getBiselesFilter('SI')" :key="index" :value="item.IdBisel">{{item.Nombre}}</option>
															</select>
															<CValidation v-if="this.errorvalidacion.IdArmazon" :Mensaje="'*'+errorvalidacion.IdArmazon[0]"/>
														</div>

														<div v-for="(item, index) in getBiselesFilter('NO')" :key="index"  class="col-2">
															<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
															<div class="form-check form-switch">
																<input v-model="objPedido.UsaBiselSencillo" @change="calculaCostoBiselSencillo(item.IdBisel)" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																<label class="form-check-label" for="CambioForma">{{ item.Nombre }}</label>
															</div>
														</div>
													</template>
													
												</div>
												<br>

												<div class="row">
													<div class="col-12 col-lg-4 col-xl-3">
														<img src="@/assets/style/image/duarte-02.png" alt="Logo" style="width: 95%;" class="">
													</div>
													<div class="col-12 col-lg-4 col-xl-2">
														<div class="row">
															<div class="col-12">
																<label class="form-label" for="DBL">* DBL</label>
																<input type="text" v-model="objPedido.DBL" class="form-control" id="DBL" placeholder="Ingresar DBL" />
																<CValidation v-if="this.errorvalidacion.DBL" :Mensaje="'*'+errorvalidacion.DBL[0]"/>
															</div>
														</div>
														<div class="row">
															<div class="col-12">
																<label class="form-label" for="ED">* ED</label>
																<input type="text" v-model="objPedido.ED" class="form-control" id="ED" placeholder="Ingresar ED" />
																<CValidation v-if="this.errorvalidacion.ED" :Mensaje="'*'+errorvalidacion.ED[0]"/>
															</div>
														</div>
														<div class="row">
															<div class="col-12">
																<label class="form-label" for="B">* B</label>
																<input type="text" v-model="objPedido.B" class="form-control" id="B" placeholder="Ingresar B" />
																<CValidation v-if="this.errorvalidacion.B" :Mensaje="'*'+errorvalidacion.B[0]"/>
															</div>
														</div>
														<div class="row">
															<div class="col-12">
																<label class="form-label" for="A">A</label>
																<input type="text" v-model="objPedido.A" class="form-control" id="A" placeholder="Ingresar A" />
																<CValidation v-if="this.errorvalidacion.A" :Mensaje="'*'+errorvalidacion.A[0]"/>
															</div>
														</div>
													</div>
													<div class="col-12 col-lg-4 col-xl-7">

														<div class="row">
															<div class="col-4">
																<h6>&nbsp;</h6><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																<div class="form-check form-switch">
																	<input v-model="objPedido.CambioForma" @change="calculaCostoForma()" class="form-check-input" type="checkbox" role="switch" id="CambioForma">
																	<label class="form-check-label" for="CambioForma">Requiere cambio de forma</label>
																</div>
															</div>
															<template v-if="objPedido.CambioForma == true">
																<div class="col-4">
																	<label class="form-label" for="EscanearForma">Escanear Forma</label>
																	<input type="text" v-model="objPedido.EscanearForma" class="form-control" id="EscanearForma" placeholder="Ingresar EscanearForma" />
																	<CValidation v-if="this.errorvalidacion.EscanearForma" :Mensaje="'*'+errorvalidacion.EscanearForma[0]"/>
																</div>
																
																<div class="col-4">
																	<label class="form-label" for="MontarArmazon">Montar en Armazon</label>
																	<input type="text" v-model="objPedido.MontarArmazon" class="form-control" id="MontarArmazon" placeholder="Ingresar MontarArmazon" />
																	<CValidation v-if="this.errorvalidacion.MontarArmazon" :Mensaje="'*'+errorvalidacion.MontarArmazon[0]"/>
																</div>
																
															</template>
															
														</div>

														<div v-if="objPedido.CambioForma == true" class="row">
															<div class="col-12">
																<h6>Realizar Aumentos</h6>
																<div class="form-check form-check-inline">
																	<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida1" value="NO">
																	<label class="form-check-label" for="AumentarMedida1">NO</label>
																</div>
																<div class="form-check form-check-inline">
																	<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida2" value="AumentarMedida">
																	<label class="form-check-label" for="AumentarMedida2">Aumentar medidas</label>
																</div>
																<div class="form-check form-check-inline">
																	<input v-model="objPedido.AumentarMedida" class="form-check-input" type="radio" name="AumentarMedida" id="AumentarMedida3" value="AumentarContorno">
																	<label class="form-check-label" for="AumentarMedida3">Aumentar contorno</label>
																</div>
															</div>
															
														</div>
														

														<div class="row">
															<template v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarMedida'">															
																<div class="col-3">
																	<label class="form-label" for="AumentarArriba">Arriba (mm)</label>
																	<input type="text" v-model="objPedido.AumentarArriba" class="form-control" id="AumentarArriba" placeholder="Ingresar AumentarArriba" />
																	<CValidation v-if="this.errorvalidacion.AumentarArriba" :Mensaje="'*'+errorvalidacion.AumentarArriba[0]"/>
																</div>
																<div class="col-3">
																	<label class="form-label" for="AumentaAbajo">Abajo (mm)</label>
																	<input type="text" v-model="objPedido.AumentaAbajo" class="form-control" id="AumentaAbajo" placeholder="Ingresar AumentaAbajo" />
																	<CValidation v-if="this.errorvalidacion.AumentaAbajo" :Mensaje="'*'+errorvalidacion.AumentaAbajo[0]"/>
																</div>
																<div class="col-3">
																	<label class="form-label" for="AumentaDerecho">Temporal (mm)</label>
																	<input type="text" v-model="objPedido.AumentaDerecho" class="form-control" id="AumentaDerecho" placeholder="Ingresar AumentaDerecho" />
																	<CValidation v-if="this.errorvalidacion.AumentaDerecho" :Mensaje="'*'+errorvalidacion.AumentaDerecho[0]"/>	
																</div>
															</template>
															<div v-if="objPedido.CambioForma == true && objPedido.AumentarMedida == 'AumentarContorno'" class="col-3">
																<label class="form-label" for="Contorno">Contorno (mm)</label>
																<input type="text" v-model="objPedido.Contorno" class="form-control" id="Contorno" placeholder="Ingresar Contorno" />
																<CValidation v-if="this.errorvalidacion.Contorno" :Mensaje="'*'+errorvalidacion.Contorno[0]"/>
															</div>
														</div>

														
														<div  class="row">
															<div class="col-4">
																<label class="form-label" for="">&nbsp;</label><!-- ESPACIADOR DE ALTURA EN BLANCO -->
																<div class="form-check form-switch">
																	<input v-model="objPedido.ReqTinte" @change="calculaCostoEntintado()" class="form-check-input" type="checkbox" role="switch" id="ReqTinte">
																	<label class="form-check-label" for="ReqTinte">Requiere entintado:</label>
																</div>
															</div>
														</div>

														<template v-if="objPedido.ReqTinte == true">
															<div class="row mt-2">
																<div class="col-12">
																	<h6 class="card-title">Color</h6>
																	<div v-for="(item7,idexcolor) in ListaColores" :key="idexcolor"  class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.IdColor" :style="'background-color:'+item7.Color+';'" :id="'ilRadioColor'+item7.IdColor" :value="item7.IdColor" 
																		:title="item7.Nombre" v-b-tooltip.hover class="form-check-input lente" type="radio" name="inlineRadioOptions" >
																		<!--<label class="form-check-label" :for="'ilRadioColor'+item7.IdColor">{{ item7.Nombre }}</label>-->
																	</div>
																</div>
															</div>

															<div class="row mt-2">
																<div class="col-12">
																	<h6 class="card-title">Tono</h6>
																	<div class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.Tono" style="background: #c3c4c5;" id="ilRadioTono" :value="1" 
																		title="Tono 1" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono1" >
																		<label class="form-check-label" for="ilRadioTono1">1</label>
																	</div>
																	<div class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.Tono" style="background: #9e9fa0;" id="ilRadioTono" :value="2" 
																		title="Tono 2" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono2" >
																		<label class="form-check-label" for="ilRadioTono2">2</label>
																	</div>

																	<div class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.Tono" style="background: #6a6a6b;" id="ilRadioTono" :value="3" 
																		title="Tono 3" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioTono3" >
																		<label class="form-check-label" for="ilRadioTono3">3</label>
																	</div>
																</div>
															</div>

															<div class="row mt-2">
																<div class="col-12">
																	<h6 class="card-title">Coloracion</h6>
																	<div class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.Coloracion" style="background: #c3c4c5;" id="ilRadioColoracion" :value="1" 
																		title="Uniforme" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion1" >
																		<label class="form-check-label" for="ilRadioColoracion1">Uniforme</label>
																	</div>
																	<div class="form-check form-check-inline mb-2">
																		<input v-model="objPedido.Coloracion" style="background: rgb(87,87,92); background: linear-gradient(180deg, rgba(87,87,92,1) 0%, rgba(207,207,207,1) 61%, rgba(254,254,254,1) 100%);" id="ilRadioColoracion" :value="2" 
																		title="Desvanecido" v-b-tooltip.hover class="form-check-input lente" type="radio" name="ilRadioColoracion2" >
																		<label class="form-check-label" for="ilRadioColoracion2">Desvanecido</label>
																	</div>
																</div>
															</div>
														</template>


														<div class="row mt-2">
															<div class="col-12">
																<label class="form-label" for="ObservacionesGeneral">Observaciones Generales</label>
																<textarea v-model="objPedido.ObservacionesGeneral" class="form-control" rows="2"></textarea>
															</div>
														</div>

														<div v-show="this.objPedido.IdTipoLente > 0" class="row mt-4">
															<div class="col-6"></div>
															<div class="col-6 text-end">
																<button @click="cambiarPaso(2)" type="button" class="btn btn-secondary me-2">Anterior</button>
																<!-- <button  type="button" class="btn btn-primary">Guardar</button> -->
															</div>
														</div>
													</div>
												</div>
											</div>

										</div>
									</div>
									
								</div>
							</div>	


							<div class="row mt-2">
								<div class="col-12">
									<div class="card">
										<div class="card-body">
											<h5 class="card-title">Resumen del Pedido</h5>
											<div class="row">
												<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
													<div class="table-responsive">
														<table class="table">
															<thead>
																<tr>
																	<th>Producto</th>
																	<th>CLAVE</th>
																	<th class="text-center">Tipo</th>
																	<th class="text-end">Precio</th>
																	<th class="text-end">Cantidad</th>
																	<th class="text-end">Importe</th>
																	
																</tr>
															</thead>
															<tbody>
																<tr v-for="(item,idnx) in detallePedido" :key="idnx">

																	<td style="vertical-align: middle !important;"><b>{{ item.Descripcion }}</b></td>
																	<td style="vertical-align: middle !important;">{{ item.Clave }}</td>
																	<td class="text-center" style="vertical-align: middle !important;">{{ item.TipoDet }}</td>
																	<td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Precio,'$') }}</td>
																	<td class="text-end" style="vertical-align: middle !important;">{{ item.Cantidad }}</td>
																	<td class="text-end" style="vertical-align: middle !important;">{{ $formatNumber(item.Importe,'$') }}</td>
																	
																</tr>
															
															</tbody>

															<tfoot class="text-end">
																<tr>
																	<td colspan="4"></td>
																	<td><h6>Subtotal</h6></td>
																	<td>{{ $formatNumber(this.objPedido.SubTotal,'$') }}</td>
																</tr>

																<tr>
																	<td colspan="4"></td>
																	<td><h6>IVA</h6></td>
																	<td>{{ $formatNumber(this.objPedido.Iva,'$') }}</td>
																</tr>
																
																<tr>
																	<td colspan="4"></td>
																	<td><h5>Total</h5></td>
																	<td><h5>{{ $formatNumber(this.objPedido.GranTotal,'$') }}</h5></td>
																</tr>
															</tfoot>

														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							
							
													
							<br>
							
						</form>
						<CBtnSave :poBtnSave="oBtnSave">
							<template slot="btnsaveextra">
								<button v-if="objPedido.Estatus == 'Cotizacion' || objPedido.Estatus == '' " type="button" class="btn mr-1" style="background-color:#7DCEA0; color:#FFF;" @click="Guardar('Cotizacion')">
									<i class="fas fa-save"></i>
									Guardar como Cotización
								</button>
							</template>
						</CBtnSave>
					</div>




				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>
import BuscadorCliente from '@/components/BuscadorCliente.vue';
import StaticComboBox from '@/helpers/StaticComboBox';

const EmitEjecuta = 'seccionPedido';

export default {
    name: 'FormPedido',
    props: ['Id','Obj'],
    components:{
		BuscadorCliente
    },
    data() {
        return {
			ConfigList:{
                Title: 'Crear Nuevo Pedido - CKS',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: '',
                EmitSeccion: EmitEjecuta,
				TxtBtnSave: 'Guardar y Enviar Pedido',
				IconBtnSave: 'fas fa-paper-plane'
            },
			locationForm: '',

			showPasos: {
				paso1: false,
				paso2: false,
				paso3: false, 
			},

            objPedido: {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0,
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',
            },

			detallePedido: [],
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
			Emit: EmitEjecuta,

			showAlertCliente: false,
			objCliente:{
				IdCliente:'',
				Clave:'',
				Nombre:''
			},

			/***************** TIPO LENTES *****************/
			
			
			ListaTipoLentes:[],
			ListPosicionesLentes: StaticComboBox.PosicionesLentes,
			TpLenteSelect: {
				IdTipoLente: 0,
				Nombre:"",
				Clave:"",
				Proceso:"0",
				Esfera:"NO",
				Cilindro:"NO",
				Eje:"NO",
				Adicion:"NO",
				AltMon:"NO",
				AltSeg:"NO",
				Dnp:"NO",
				Prisma:"NO",
				Posicion:"NO",
				ValMinMon:"0",
				ValMaxMon:"0",
				ValMinSeg:"0",
				ValMaxSeg:"0",
			},
			lentesSinSubLinea:[2,3,10,11], //includes
			procesoActivo: 0,
			showNumParesLentes: false,


			/***************** TABLA DE RX *****************/
			showRXLentes: false,

			// CONTROL DE ESFERAS 
			EsferaDerecha:{
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			EsferaIzquierda:{
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			// CONTROL DE CILINDROS 
			CilindroDerecho: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
				blockEje: true,
			},
			CilindroIzquierdo: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
				blockEje: true
			},

			// CONTROL DE RANGOS ADICIONALES
			RanAdicionalDerecho: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},
			RanAdicionalIzquierdo: {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			toolTipRX: {
				// EJE
				showToolOdEje: 			false,
				showToolOdEjeRequire: 	false,
				showToolOiEje: 			false,
				showToolOiEjeRequire: 	false,

				// ALT MONTURA
				showToolOdAltMon: 		false,
				showToolOiAltMon: 		false,

				// ALT SEGMENTO
				showToolOdAltSeg: 		false,
				showToolOiAltSeg: 		false,

				// DNP
				showToolOdDnp: 			false,
				showToolOiDnp: 			false,

				// PRISMA
				showToolOdPrisma: 		false,
				showToolOiPrisma: 		false,

				// SECCION DE PERSONALIZACION
				showToolAngPantos: 		false,
				showToolAngPanoram: 	false,
				showToolDistVertice: 	false,
				showToolDistLectura: 	false,
				showToolIniciales: 		false,
				showPopArticulo: 		false,
				showPopMaterial: 		false,
			},

			// SUBLINEAS
			ListaSublineas: [],

			// ARTICULOS WEB
			bndBloqueoArticulo: false,
			ListaArticulosWeb: [],
			articuloWebSelect: {
				IdArticuloWeb: 0,
				IdSublinea: 0,
				IdTipoLente: 0,
				Nombre: "",
				Clave: "",
				ReqTratExt: "NO",
				ReqTratamiento: "NO",
				AnguloPantoscopico: "NO",
				AnguloPanoramico: "NO",
				DistanciaVertice: "NO",
				DistanciaLectura: "NO",
				Iniciales: "NO",
				ReqTratInt: "NO",
				ReqEjeAdd: "NO",
				SolicitaListado: "",
				ViewSeccion: false,
				Seleccionable: true,
			},


			// MATERIALES
			ListaMateriales: [],
			bndBloqueoMaterial: false,
			materialSelect: {
				Seleccionable: '',
				RazonBloqueo: ''
			},

			// PROTECCIONES
			bndBloqueoProtxRecub: true,
			ListaProtecciones: [],

			// RECUBRIMIENTOS
			ListaRecubrimientos: [],

			// ARMAZONES
			ListaArmazones: [],

			// BISELES
			ListaBiseles: [],

			// COLORES
			ListaColores: [],
        }
    },
    methods :
    {	
		validaGuardado() {

			let proceso = parseInt(this.TpLenteSelect.Proceso);
			let bndVerificacion = true;

			switch (proceso) {

				case 1:

					if(this.objPedido.IdArmazon == 0 || this.objPedido.IdArmazon == '' || this.objPedido.IdArmazon == null || this.objPedido.IdArmazon == undefined) {
						this.$toast.info('Se requiere selecciona un tipo de armazón'); 
						bndVerificacion = false; 
					}

					let countErros = 0;
					let banderas = {
						DBL: false,
						ED: false,
						B: false,
						A: false,
					};

					if(this.objPedido.DBL == '' || this.objPedido.DBL == '' || this.objPedido.DBL == null || this.objPedido.DBL == undefined) {
						countErros++;
						banderas.DBL = true;
					}

					if(this.objPedido.ED == '' || this.objPedido.ED == '' || this.objPedido.ED == null || this.objPedido.ED == undefined) {
						countErros++;
						banderas.ED = true;
					}

					if(this.objPedido.B == '' || this.objPedido.B == '' || this.objPedido.B == null || this.objPedido.B == undefined) {
						countErros++;
						banderas.B = true;
					}

					if(this.objPedido.A == '' || this.objPedido.A == '' || this.objPedido.A == null || this.objPedido.A == undefined) {
						countErros++;
						banderas.A = true;
					}


					if(countErros > 1) {
						this.$toast.warning('Se requiere completar las medidas del Armazón');
						bndVerificacion = false;

					}else {
						if(banderas.DBL) { this.$toast.info('Se requiere de un valor para DBL'); bndVerificacion = false; }
						if(banderas.ED) { this.$toast.info('Se requiere de un valor para ED'); bndVerificacion = false;  }
						if(banderas.B) { this.$toast.info('Se requiere de un valor para B'); bndVerificacion = false;  }
						if(banderas.A) { this.$toast.info('Se requiere de un valor para A'); bndVerificacion = false;  }
					}

					break;
					
			}

			return bndVerificacion;
			
		},


		async Guardar(ptpSave = 'Cotizacion')
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
		
			//this.objPedido.Cliente = this.objCliente;
			this.objPedido.Estatus 			= ptpSave;
			this.objPedido.detallePedido 	= this.detallePedido;
			//this.validaGuardado();
			
			if(this.validaGuardado() == true) {
				console.log('Guardando de funcion...');
		
				await this.$http.post(
					'pedidos', this.objPedido
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
				
			}else {
				this.oBtnSave.DisableBtn = false;
			}
			
        },

		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "pedidos/"+this.objPedido.IdPedido
            ).then((res) => {
                this.objPedido = res.data.data;
				this.objCliente  = this.objPedido.cliente;
				this.detallePedido = this.objPedido.detalle;
				this.setCliente(this.objCliente);

				this.ConfigList.Title = '';
				if(this.objPedido.Estatus == 'Cotizacion') {
					this.ConfigList.Title = 'Cotizacion #'+this.objPedido.FolioCotizacion;
				}else {
					this.ConfigList.Title = 'Pedido #'+this.objPedido.FolioPedido;
				}

				this.selectorProceso(false,true);
				

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objPedido.Fecha.replace(/-/g,'\/');
                this.objPedido.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {	
			console.log('limpiando General');
            this.objPedido = {
				IdPedido: 0,
				IdCliente: 0,
				IdUsuario: 0,
				IdSubLinea: 0,
				IdArticuloWeb: 0,
				IdMaterial: 0,
				IdProteccion: 0,
				IdRecubrimiento: 0,
				IdArmazon: 0,
				IdBisel: 0,
				IdTipoLente: 0,
				Estatus: '',
				FolioCotizacion: '',
				FolioPedido: '',
				Fecha: '',
				Paciente: '',

				OjoDerecho: true,
				OdEsfera: '',
				OdCilindro: '',
				OdEje: '',
				OdAdicion: '',
				OdPrisma: '',
				OdDnp: '',
				OdAltMon: '',
				OdAltSeg: '',
				OdPosicion: '',

				OjoIzquierdo: true,
				OiEsfera: '',
				OiCilindro: '',
				OiEje: '',
				OiAdicion: '',
				OiPrisma: '',
				OiDnp: '',
				OiAltMon: '',
				OiAltSeg: '',
				OiPosicion: '',

				ReqTinte: '',
				IdColor: 0,
				Color: '',
				Tono: '',
				Coloracion: '',
				NumPar: 0,
			
				UsaBiselSencillo: false,
				IdBiselSencillo: 0,
				IdSubBisel: 0, //'NINGUNO',
				NumGrapas: 0,

				Perforacion: '',
				
				ObservacionesGeneral: '',
				SubLinea: '',
				Articulo: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				Armazon: '',
				AnguloPantoscopico: '',
				AnguloPanoramico: '',
				DistanciaVertice: '',
				DistanciaLectura: '',
				Iniciales: '',

				// PASO 3
				EnviaArmazon: false,
				MarcaArmazon: '',
				ColorArmazon: '',
				ModeloArmazon: '',
				EstadoArmazon: '',

				CambioForma: '',
				EscanearForma: '',
				MontarArmazon: '',
				AumentarArriba: '',
				AumentaAbajo: '',
				AumentaDerecho: '',
				Contorno: '',
				DBL: '',
				ED: '',
				B: '',
				A: '',
				AumentarMedida: 'NO',
				
				SubTotal: 0,
				Iva: 0,
				GranTotal: 0,
				FolioEnviado: '',
				Insertado: '',
				
            },
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },

		cambiarPaso(tp, val = false){
			switch (tp) {
				case 1:
					this.showPasos = {
						paso1: true,
						paso2: false,
						paso3: false, 
					};
					break;

				case 2:
					if( this.validaCambioPaso(2) == true ) {
						this.showPasos = {
							paso1: false,
							paso2: true,
							paso3: false, 
						};
						
					}else {
						this.$toast.warning('Complete los campos.')
					}

					break;

				case 3:
					if( this.validaCambioPaso(3) == true) {
						this.showPasos = {
							paso1: false,
							paso2: false,
							paso3: true, 
						};
					}
					
					break;
			
			}
		},

		validaCambioPaso (pPaso = 0) {
			
			switch (pPaso) {
				case 2:

					if(this.procesoActivo > 0) {

						if(this.procesoActivo == 1) {

							if( this.lentesSinSubLinea.includes(parseInt(this.TpLenteSelect.IdTipoLente)) ) {
								console.log('Tipo de lente sin sublinea');
								this.getArticulosWeb();
							}
							
							if(this.objPedido.OjoDerecho == true) {

								// CAMPOS NO OBLIGATORIOS
								// VALIDAR SIEMPRE Y CUANDO EL CAMPO SE ENCUENTRE ACTIVO Y SEA DIFERENTE DE VACIO, 

								if(this.TpLenteSelect.Esfera == 'SI' && this.objPedido.OdEsfera != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;
								}

								if(this.TpLenteSelect.Cilindro == 'SI' && this.objPedido.OdCilindro != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;

									if(this.objPedido.OdEje == '') {
										this.toolTipRX.showToolOdEjeRequire = true;
										return false;
									}
								}
								
								// CAMPOS OBLIGATORIOS - CAMBIANTES
								// ** VALIDAREMOS CAMPOS CADA OJO SI SE ENCUENTRA ACTIVO 

								if(this.TpLenteSelect.Adicion == 'SI' && this.objPedido.OdAdicion == '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									this.RanAdicionalDerecho.showTool = true;
									return false;
								}

								// ALTURA DE MONTURA
								if(this.TpLenteSelect.AltMon == 'SI') { 
									if ( this.objPedido.OdAltMon == '' || this.objPedido.OdAltMon <= 0) {
										this.toolTipRX.showToolOdAltMon = true;
										return false;
									}
								}

								// DNP
								if(this.TpLenteSelect.Dnp == 'SI') {
									if(this.objPedido.OdDnp == '' || this.objPedido.OdDnp <= 0) {
										this.toolTipRX.showToolOdDnp = true;
										return false;
									}
								}							}

							if(this.objPedido.OjoIzquierdo == true) {

								// CAMPOS NO OBLIGATORIOS
								// VALIDAR SIEMPRE Y CUANDO EL CAMPO SE ENCUENTRE ACTIVO Y SEA DIFERENTE DE VACIO, 

								if(this.TpLenteSelect.Esfera == 'SI' && this.objPedido.OiEsfera != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;
								}

								if(this.TpLenteSelect.Cilindro == 'SI' && this.objPedido.OiCilindro != '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									//return false;

									if(this.objPedido.OiEje == '') {
										this.toolTipRX.showToolOiEjeRequire = true;
										return false;
									}
								}


								// CAMPOS OPCIONALES
								// ** VALIDAREMOS CAMPOS CADA OJO SI SE ENCUENTRA ACTIVO 
								if(this.TpLenteSelect.Adicion == 'SI' && this.objPedido.OiAdicion == '') {
									//FIX REQUIERE DE VERICAR CON PRECISION SI EL VALOR COLOCADO CORRESPONDE A UN VALOR VALIDO EN BD
									this.RanAdicionalIzquierdo.showTool = true;
									return false;
								}

								// ALTURA DE MONTURA
								if(this.TpLenteSelect.AltMon == 'SI') { 
									if ( this.objPedido.OiAltMon == '' || this.objPedido.OiAltMon <= 0) {
										this.toolTipRX.showToolOiAltMon = true;
										return false;
									}
								}

								// DNP
								if(this.TpLenteSelect.Dnp == 'SI') {
									if(this.objPedido.OiDnp == '' || this.objPedido.OiDnp <= 0) {
										this.toolTipRX.showToolOiDnp = true;
										return false;
									}
								}
								
							}

							return true;
							

							
						}else if (this.procesoActivo == 2) {
							console.log('entra en valid proceso 2');
							if(parseInt(this.objPedido.NumPar) == 0 || this.objPedido.NumPar == '' || this.objPedido.NumPar == undefined) {
								this.$toast.info('Requiere seleccionar la cantidad de lentes');
								return false;
							}
							
						}
					}

					break;

				case 3:
					if(this.procesoActivo > 0) {

						if(this.procesoActivo == 1) {

							if ( this.objPedido.IdSubLinea== '' || this.objPedido.IdSubLinea <= 0) {
								this.toolTipRX.showToolIdSubLinea = true;
								this.$toast.info('Requiere seleccionar una sublinea');
								return false;
							}

							if( this.objPedido.IdArticuloWeb == '' ||  this.objPedido.IdArticuloWeb == 0) {
								this.toolTipRX.showToolIdArticuloWeb = true;
								this.$toast.info('Requiere seleccionar un articulo');
								return false;
							}

							if ( this.objPedido.IdMaterial== '' || this.objPedido.IdMaterial <= 0) {
								this.toolTipRX.showToolIdMaterial = true;
								this.$toast.info('Requiere seleccionar un material');
								return false;
							}

							if ( this.objPedido.IdRecubrimiento== '' || this.objPedido.IdRecubrimiento <= 0) {
								this.toolTipRX.showToolIdRecubrimiento = true;
								this.$toast.info('Requiere seleccionar un recubrimiento');
								return false;
							}

							if ( this.objPedido.IdProteccion== '' || this.objPedido.IdProteccion <= 0) {
								this.toolTipRX.showToolIdProteccion = true;
								this.$toast.info('Requiere seleccionar una protección');
								return false;
							}

							// SECCION DE CAMPOS VARIABLES SEGUN CONFIGURACION DE ARTICULO WEB
							let countErros = 0;
							let banderas = {
								AngPantos: false,
								AngPanoram: false,
								DistVertice: false,
								DistLectura: false,
								Iniciales: false,
							};
							if( this.articuloWebSelect.AnguloPantoscopico == 'SI' ) {
								if (this.objPedido.AnguloPantoscopico == '') {
									this.toolTipRX.showToolAngPantos = true;
									countErros++;
									banderas.AngPantos = true;

								}else {
									this.validaRangosRX('AngPantos');
								}
							}

							if( this.articuloWebSelect.AnguloPanoramico == 'SI' ) {
								if (this.objPedido.AnguloPanoramico == '') {
									this.toolTipRX.showToolAngPanoram = true;
									countErros++;
									banderas.AngPanoram = true;
					
								}else {
									this.validaRangosRX('AngPanoram');
								}
							}
							
							if( this.articuloWebSelect.DistanciaVertice == 'SI' ) {
								if (this.objPedido.DistanciaVertice == '') {
									this.toolTipRX.showToolDistVertice = true;
									countErros++;
									banderas.DistVertice = true;
									
								}else {
									this.validaRangosRX('DistVertice');
								}
							}

							if( this.articuloWebSelect.DistanciaLectura == 'SI' ) {
								if (this.objPedido.DistanciaLectura == '') {
									this.toolTipRX.showToolDistLectura = true;
									countErros++;
									banderas.DistLectura = true;
									;
								}else {
									this.validaRangosRX('DistLectura');
								}
							}

							if(this.articuloWebSelect.Iniciales == 'SI'){
								if(this.objPedido.Iniciales == ''){
									this.toolTipRX.showToolIniciales = true;
									countErros++;
									banderas.Iniciales = true;
									
								}
							}
							
							if(countErros > 1) {
								this.$toast.warning('Se requiere completar los campos');
								return false
							}else {
								if(banderas.AngPantos) { this.$toast.info('Se requiere de un valor para Angulo Pantoscopico'); return false }
								if(banderas.AngPanoram) { this.$toast.info('Se requiere de un valor para Angulo Panoramico'); return false  }
								if(banderas.DistVertice) { this.$toast.info('Se requiere de un valor para Distancia de Vertice'); return false  }
								if(banderas.DistLectura) { this.$toast.info('Se requiere de un valor para Distancia de Lectura'); return false  }
								if(banderas.Iniciales) { this.$toast.info('Se requiere de un valor para Iniciales'); return false  }
							}


							return true;

						}

					}

					break;
			
				
			}
			
		},

		/***************** CLIENTE *****************/ 
		getCliente() {
            
            this.$http.get( `/clientes/${this.objCliente.IdCliente}` )
            .then( res => {
                const cliente = res.data.data;
                this.objCliente = cliente;
				this.objPedido.IdCliente = cliente.IdCliente
                

            }).catch( err => {

            	this.limpiaCliente();
            });
        },

    	setCliente( cliente = {} ) {
			console.log('SettingCliente');
        	const buscadorCliente = this.$refs.buscadorCliente;
            buscadorCliente.clientes.push({
                label: `${cliente.Nombre}`,
                detalle: {
                    clave: cliente.Clave,
					Rfc: cliente.Rfc,
                },
				key: cliente.IdCliente,
        	});

        },

		limpiaCliente(){
            this.objCliente = {
                NombreComercial: '',
                RazonSocial: '',
                Rfc: '',
                Contacto: '',
                Telefono: '',
                Correo: '',
                Direccion:'',
                Calle: '',
                NoInt: '',
                NoExt: '',
                Colonia: '',
                Cp: '',
                Cruzamiento1: '',
                Cruzamiento2: '',
                Referencias: '',
                IdEstado: '',
                IdMunicipio: '',
            }
        },

		/***************** TIPO LENTES *****************/ 
		getListTiposLentes()
		{
			this.$http.get("tiposlentes", {
				params:{
					isSimple: 1,
				}
			}).then((res) => {
				this.ListaTipoLentes = res.data.data;
			});
		},

		selectorProceso(pClean = true, pRecovery = false) {
		
			if(parseInt(this.objPedido.IdTipoLente) > 0) {
				let clean = pClean ? 1 :0;
				let array = this.ListaTipoLentes.filter(item => item.IdTipoLente == this.objPedido.IdTipoLente);

				if( array != undefined && this.objCliente.IdCliente > 0 ) {
					this.TpLenteSelect = array[0];
					
					switch (parseInt(this.TpLenteSelect.Proceso)) {
						case 1:
							console.log('Tipo Tabla Lente RX');
							this.limpiaRXDerecho(clean);
							this.limpiaRXIzquierdo(clean);
							this.showNumParesLentes 	= false;
							this.objPedido.NumPar 		= 0;

							this.objPedido.OjoDerecho 	= true;
							this.objPedido.OjoIzquierdo = true;
							this.showRXLentes 			= true;
							this.procesoActivo 			= 1;
		
							if( this.lentesSinSubLinea.includes(parseInt(this.TpLenteSelect.IdTipoLente)) ) {
								this.objPedido.IdSubLinea = 13;

							}else {
								this.getSublinea();
							}

							if(pRecovery) {
								this.getArticulosWeb(true);
								//this.getMateriales ();
							}
							break;

						case 2:
							// LIMPIAMOS Y APAGAMOS CONFIGURACIONES DE OTROS TIPOS
							this.limpiaRXDerecho(1);
							this.limpiaRXIzquierdo(1);
							this.objPedido.OjoDerecho 	= false;
							this.objPedido.OjoIzquierdo = false;
							this.showRXLentes 			= false;

							this.showNumParesLentes 	= true;
							this.objPedido.NumPar 		= 0;
							this.procesoActivo 			= 2;
							console.log('Tipo Lente Terminado');

							if(pRecovery) {
								this.getArticulosWeb(true);
							}

							break;

						case 3:
							this.limpiaRXDerecho(1);
							this.limpiaRXIzquierdo(1);
							this.objPedido.OjoDerecho 	= false;
							this.objPedido.OjoIzquierdo = false;
							this.showRXLentes 			= false;
							this.showNumParesLentes 	= false;
							this.objPedido.NumPar 		= 0;
							this.procesoActivo 			= 3;

							console.log('Tabla de obtrias para lentes de contacto');
							break;

					}

				}else {
					if( this.objCliente.IdCliente == 0 ){
						this.$toast.info('Necesitas seleccionar un cliente');
						this.objPedido.IdTipoLente = 0;
						//this.showAlertCliente = true;
					}

					this.limpiaRXDerecho(1);
					this.limpiaRXIzquierdo(1);
					this.objPedido.OjoDerecho 	= false;
					this.objPedido.OjoIzquierdo = false;
					this.showRXLentes 			= false;
					this.showNumParesLentes 	= false;
					this.objPedido.NumPar 		= 0;
				}
			}else {
				this.limpiaRXDerecho(1);
				this.limpiaRXIzquierdo(1);
				this.objPedido.OjoDerecho 	= false;
				this.objPedido.OjoIzquierdo = false;
				this.showRXLentes 			= false;
				this.showNumParesLentes 	= false;
				this.objPedido.NumPar 		= 0;
			}
			
			
		},


		/***************** TABLA DE RX *****************/

		limpiaRXDerecho(op = 0) {
			if(this.objPedido.OjoDerecho == false || op > 0) {

				this.objPedido.OdEsfera		= '';
				this.objPedido.OdCilindro	= '';
				this.objPedido.OdEje 		= '';
				this.objPedido.OdAdicion	= '';
				this.objPedido.OdPrisma		= '';
				this.objPedido.OdDnp		= '';
				this.objPedido.OdAltMon		= '';
				this.objPedido.OdAltSeg		= '';
				this.objPedido.OdPosicion	= '';
			}
		},

		limpiaRXIzquierdo(op = 0) {
			if(this.objPedido.OjoIzquierdo == false || op > 0) {

				this.objPedido.OiEsfera		= '';
				this.objPedido.OiCilindro	= '';
				this.objPedido.OiEje 		= '';
				this.objPedido.OiAdicion	= '';
				this.objPedido.OiPrisma		= '';
				this.objPedido.OiDnp		= '';
				this.objPedido.OiAltMon		= '';
				this.objPedido.OiAltSeg		= '';
				this.objPedido.OiPosicion	= '';
			}
				
		},

		limpiarConfLente(tp){

			switch (tp) {
				case 'sublinea':
					this.objPedido.IdArticuloWeb 	= 0;
					this.objPedido.IdMaterial 		= 0;
					this.objPedido.IdProteccion 	= 0;
					this.objPedido.IdRecubrimiento 	= 0;

					this.articuloWebSelect = {
						IdArticuloWeb: 0,
						IdSublinea: 0,
						IdTipoLente: 0,
						Nombre: "",
						Clave: "",
						ReqTratExt: "NO",
						ReqTratamiento: "NO",
						AnguloPantoscopico: "NO",
						AnguloPanoramico: "NO",
						DistanciaVertice: "NO",
						DistanciaLectura: "NO",
						Iniciales: "NO",
						ReqTratInt: "NO",
						ReqEjeAdd: "NO",
						SolicitaListado: "",
						ViewSeccion: false,
						Seleccionable: true,
					};

					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
					break;

				case 'armazon':
					this.objPedido.EstadoArmazon 	= '';
					this.objPedido.MarcaArmazon 	= '';
					this.objPedido.ModeloArmazon 	= '';
					this.objPedido.ColorArmazon 	= '';
					
					break;
				
				case 'biselsencillo':
					this.objPedido.UsaBiselSencillo = false;
					this.objPedido.IdBiselSencillo  = 0;

					break;
			
				default:
					this.objPedido.IdSubLinea 		= 13;
					this.objPedido.IdArticuloWeb 	= 0;
					this.objPedido.IdMaterial 		= 0;
					this.objPedido.IdProteccion 	= 0;
					this.objPedido.IdRecubrimiento 	= 0;

					this.articuloWebSelect = {
						IdArticuloWeb: 0,
						IdSublinea: 0,
						IdTipoLente: 0,
						Nombre: "",
						Clave: "",
						AnguloPantoscopico: "NO",
						AnguloPanoramico: "NO",
						DistanciaVertice: "NO",
						DistanciaLectura: "NO",
						Iniciales: "NO",
						ReqTratInt: "NO",
						ReqEjeAdd: "NO",
						ReqTratExt: "NO",
						ReqTratamiento: "NO",
						
						SolicitaListado: "",
						ViewSeccion: false,
						Seleccionable: true,
					};

					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
					break;
			}
			
		},

		// EJECUTA LA BUSQUEDA POR API DE VALORES ESCRITOS EN LOS CAMPOS DE LA TABLA RX
		accionInput(id,tipo = ''){
			
			let signo = '';
			let valInicial = '';
			this.limpiarConfLente();

			switch (tipo) {
				case 'Esfera':	
					if(id == 'OdEsfera') {
						this.EsferaDerecha.showTool 	= false;
						this.EsferaDerecha.showPopOver 	= false;
						this.EsferaDerecha.listaMedidas = [];


						this.objPedido.OdEsfera = this.objPedido.OdEsfera.trim();
						signo 		= this.objPedido.OdEsfera.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdEsfera.substring(1,this.objPedido.OdEsfera.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdEsfera = '';
							this.EsferaDerecha.showTool = true;
							
						}
					}

					if(id == 'OiEsfera') {

						this.EsferaIzquierda.showTool 		= false;
						this.EsferaIzquierda.showPopOver 	= false;
						this.EsferaIzquierda.listaMedidas 	= [];

						this.objPedido.OiEsfera = this.objPedido.OiEsfera.trim();
						signo 		= this.objPedido.OiEsfera.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiEsfera.substring(1,this.objPedido.OiEsfera.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}

						}else {
							valInicial 	=  '';
							this.objPedido.OiEsfera = '';
							this.EsferaIzquierda.showTool = true;
							
						}
					}

				break;

				case 'Cilindro':
					if(id == 'OdCilindro') {
						this.CilindroDerecho.showTool 		= false;
						this.CilindroDerecho.showPopOver 	= false;
						this.CilindroDerecho.listaMedidas 	= [];
						this.CilindroDerecho.blockEje 		= true;
						this.objPedido.OdEje 				= '';

						this.objPedido.OdCilindro = this.objPedido.OdCilindro.trim();
						signo 		= this.objPedido.OdCilindro.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdCilindro.substring(1,this.objPedido.OdCilindro.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdCilindro 		= '';
							this.CilindroDerecho.showTool 	= true;
							
						}
					}

					if(id == 'OiCilindro') {

						this.CilindroIzquierdo.showTool 		= false;
						this.CilindroIzquierdo.showPopOver 		= false;
						this.CilindroIzquierdo.listaMedidas 	= [];
						this.CilindroIzquierdo.blockEje 		= true;
						this.objPedido.OiEje 					= '';

						this.objPedido.OiCilindro = this.objPedido.OiCilindro.trim();
						signo 		= this.objPedido.OiCilindro.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiCilindro.substring(1,this.objPedido.OiCilindro.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}

						}else {
							valInicial 	=  '';
							this.objPedido.OiCilindro = '';
							this.CilindroIzquierdo.showTool = true;
							
						}
					}
					break;

				case 'RangoAdicional':
					if(id == 'OdAdicion') {
						this.RanAdicionalDerecho.showTool 	= false;
						this.RanAdicionalDerecho.showPopOver 	= false;
						this.RanAdicionalDerecho.listaMedidas = [];


						this.objPedido.OdAdicion = this.objPedido.OdAdicion.trim();
						signo 		= this.objPedido.OdAdicion.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OdAdicion.substring(1,this.objPedido.OdAdicion.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OdAdicion = '';
							this.RanAdicionalDerecho.showTool = true;
							
						}
					}

					if(id == 'OiAdicion') {
						this.RanAdicionalIzquierdo.showTool 	= false;
						this.RanAdicionalIzquierdo.showPopOver 	= false;
						this.RanAdicionalIzquierdo.listaMedidas = [];


						this.objPedido.OiAdicion = this.objPedido.OiAdicion.trim();
						signo 		= this.objPedido.OiAdicion.substring(0,1);
						
						if(signo == '+' || signo == '-') {
							valInicial 	=  this.objPedido.OiAdicion.substring(1,this.objPedido.OiAdicion.length);
							
							if(valInicial.length == 0) {
								valInicial = 0;
							}
							
						}else {
							valInicial 	=  '';
							this.objPedido.OiAdicion = '';
							this.RanAdicionalIzquierdo.showTool = true;
							
						}
					}

					break;

				case 'Eje':
					
					break;
				
			}

			console.log('ValIni: '+valInicial);
			console.log('Signo: '+signo);
			console.log('tipo: '+tipo);

			if(valInicial !== '' && signo != '' && tipo != '') {

				this.$http.get("opgraduacionesrxs", {
					params:{
						Signo: signo,
						Tipo: tipo,
						ValorInicial: valInicial
					}
				}).then((res) => {
					console.log(res.data);

					switch (tipo) {
						case 'Esfera':
							if(id == 'OdEsfera') {
								this.EsferaDerecha.listaMedidas = res.data.data;
								this.EsferaDerecha.showPopOver = true;
							}

							if(id == 'OiEsfera') {
								this.EsferaIzquierda.listaMedidas = res.data.data;
								this.EsferaIzquierda.showPopOver = true;
							}

							break;

						case 'Cilindro':
							if(id == 'OdCilindro') {
								this.CilindroDerecho.listaMedidas = res.data.data;
								this.CilindroDerecho.showPopOver = true;
							}

							if(id == 'OiCilindro') {
								this.CilindroIzquierdo.listaMedidas = res.data.data;
								this.CilindroIzquierdo.showPopOver = true;
							}

							break;

						case 'RangoAdicional':
							if(id == 'OdAdicion') {
								this.RanAdicionalDerecho.listaMedidas = res.data.data;
								this.RanAdicionalDerecho.showPopOver = true;
							}

							if(id == 'OiAdicion') {
								this.RanAdicionalIzquierdo.listaMedidas = res.data.data;
								this.RanAdicionalIzquierdo.showPopOver = true;
							}

							break;
					}


				}).finally(()=>{
					
				});
			}
			
		},

		// VALIDA QUE LA ESCRITURA DE LOS RANGOS DE VALORES EN LA TABLA RX SEAN CORRECTOS
		validaRangosRX (tipo = '', id = '') {
			this.toolTipRX = {
				// EJE
				showToolOdEje: 			false,
				showToolOdEjeRequire: 	false,
				showToolOiEje: 			false,
				showToolOiEjeRequire: 	false,

				// ALT MONTURA
				showToolOdAltMon: 		false,
				showToolOiAltMon: 		false,

				// ALT SEGMENTO
				showToolOdAltSeg: 		false,
				showToolOiAltSeg: 		false,

				// DNP
				showToolOdDnp: 			false,
				showToolOiDnp: 			false,

				// PRISMA
				showToolOdPrisma: 		false,
				showToolOiPrisma: 		false,

				// SECCION DE PERSONALIZACION
				showToolAngPantos: 		false,
				showToolAngPanoram: 	false,
				showToolDistVertice: 	false,
				showToolDistLectura: 	false,
				showToolIniciales: 		false,

				showPopArticulo: 		false
			};
			
			switch (tipo) {

				case 'Eje':
					if(id == 'OdEje') { 
						if (this.objPedido.OdEje < 0 || this.objPedido.OdEje > 180 ){
							this.objPedido.OdEje = '';
							this.toolTipRX.showToolOdEje = true;
						}
					}
					if(id == 'OiEje') { 
						if (this.objPedido.OiEje < 0 || this.objPedido.OiEje > 180 ){
							this.objPedido.OiEje = '';
							this.toolTipRX.showToolOiEje = true;
						}
					}
					break;

				case 'AltMont':
					if(id == 'OdAltMon') { 
					
						if (parseInt(this.objPedido.OdAltMon) < parseInt(this.TpLenteSelect.ValMinMon) || this.objPedido.OdAltMon > parseInt(this.TpLenteSelect.ValMaxMon) ) {
							this.objPedido.OdAltMon = '';
							this.toolTipRX.showToolOdAltMon = true;

							return false;
						}
						return true;
					}
					if(id == 'OiAltMon') { 
						if (parseInt(this.objPedido.OiAltMon) < parseInt(this.TpLenteSelect.ValMinMon) || this.objPedido.OiAltMon > parseInt(this.TpLenteSelect.ValMaxMon) ) {
							this.objPedido.OiAltMon = '';
							this.toolTipRX.showToolOiAltMon = true;
						}
					}
					break;
				
				case 'AltSeg':
					if(id == 'OdAltSeg') { 
						if (parseInt(this.objPedido.OdAltSeg) < parseInt(this.TpLenteSelect.ValMinSeg) || this.objPedido.OdAltSeg > parseInt(this.TpLenteSelect.ValMaxSeg) ) {
							this.objPedido.OdAltSeg = '';
							this.toolTipRX.showToolOdAltSeg = true;
						}
					}
					if(id == 'OiAltSeg') { 
						if (parseInt(this.objPedido.OiAltSeg) < parseInt(this.TpLenteSelect.ValMinSeg) || this.objPedido.OiAltSeg > parseInt(this.TpLenteSelect.ValMaxSeg) ) {
							this.objPedido.OiAltSeg = '';
							this.toolTipRX.showToolOiAltSeg = true;
						}
					}
					break;

				case 'Dnp':
					if(id == 'OdDnp') { 
						if (this.objPedido.OdDnp < 20 || this.objPedido.OdDnp > 50 ) {
							this.objPedido.OdDnp = '';
							this.toolTipRX.showToolOdDnp = true;
						}
					}
					if(id == 'OiDnp') { 
						if (this.objPedido.OiDnp < 20 || this.objPedido.OiDnp > 50 ) {
							this.objPedido.OiDnp = '';
							this.toolTipRX.showToolOiDnp = true;
						}
					}
					break;

				case 'Prisma':
					if(id == 'OdPrisma') { 
						if (this.objPedido.OdPrisma < 0 || this.objPedido.OdPrisma > 15 ) {
							this.objPedido.OdPrisma = '';
							this.toolTipRX.showToolOdPrisma = true;
						}
					}
					if(id == 'OiPrisma') { 
						if (this.objPedido.OiPrisma < 0 || this.objPedido.OiPrisma > 15 ) {
							this.objPedido.OiPrisma = '';
							this.toolTipRX.showToolOiPrisma = true;
						}
					}
					break;
				
				case 'AngPantos':
					if (this.objPedido.AnguloPantoscopico < 0 || this.objPedido.AnguloPantoscopico > 20 ) {
						this.objPedido.AnguloPantoscopico = '';
						this.toolTipRX.showToolAngPantos = true;
					}
					break;

				case 'AngPanoram':
					if (this.objPedido.AnguloPanoramico < 0 || this.objPedido.AnguloPanoramico > 20 ) {
						this.objPedido.AnguloPanoramico = '';
						this.toolTipRX.showToolAngPanoram = true;
					}
					break;

				case 'DistVertice':
					if (this.objPedido.DistanciaVertice < 0 || this.objPedido.DistanciaVertice > 40 ) {
						this.objPedido.DistanciaVertice = '';
						this.toolTipRX.showToolDistVertice = true;
					}
					break;

				case 'DistLectura':
					if (this.objPedido.DistanciaLectura < 0 || this.objPedido.DistanciaLectura > 40 ) {
						this.objPedido.DistanciaLectura = '';
						this.toolTipRX.showToolDistLectura = true;
					}
					break;
			
			}
		},

		// FUNCION ENCARGADA DE CARGAR EL VALOR A LA VARIABLE CORRESPONDIENTE BASADA EN LA SELECCION DEL USUARIO EN EL POOPOVER
		setValor(valor = '', tipo = '', id = '') {
			
			console.log(tipo);

			switch (tipo) {

				case 'Esfera':

					if(id == 'OdEsfera') {
						this.EsferaDerecha.showTool 	= false;
						this.EsferaDerecha.showPopOver 	= false;
						
						this.objPedido.OdEsfera = '';
						this.objPedido.OdEsfera = valor.trim();
					}

					if(id == 'OiEsfera') {

						this.EsferaIzquierda.showTool 		= false;
						this.EsferaIzquierda.showPopOver 	= false;
						
						this.objPedido.OiEsfera = '';
						this.objPedido.OiEsfera = valor.trim();
					}

				break;

				case 'Cilindro':
				
					if(id == 'OdCilindro') {
						this.CilindroDerecho.showTool 		= false;
						this.CilindroDerecho.showPopOver 	= false;
						
						this.objPedido.OdCilindro 			= '';
						this.objPedido.OdCilindro			= valor;
						this.CilindroDerecho.blockEje 		= false;
					}

					if(id == 'OiCilindro') {

						this.CilindroIzquierdo.showTool 	= false;
						this.CilindroIzquierdo.showPopOver 	= false;
						
						this.objPedido.OiCilindro 			= '';
						this.objPedido.OiCilindro 			= valor;
						this.CilindroIzquierdo.blockEje 	= false;
					}

				break;

				case 'RangoAdicional':

					if(id == 'OdAdicion') {
						this.RanAdicionalDerecho.showTool 		= false;
						this.RanAdicionalDerecho.showPopOver 	= false;
						
						this.objPedido.OdAdicion = '';
						this.objPedido.OdAdicion = valor.trim();
						this.copiaAdicion(valor.trim(), id);
					}

					if(id == 'OiAdicion') {
						this.RanAdicionalIzquierdo.showTool 	= false;
						this.RanAdicionalIzquierdo.showPopOver 	= false;
						
						this.objPedido.OiAdicion = '';
						this.objPedido.OiAdicion = valor.trim();
						this.copiaAdicion(valor.trim(), id);
					}

				break;
			}
		},

		copiaAdicion(pValor = '', id = '') {
			
			// SI SE RECIBE ID LADO DERECHO, VERIFICAMOS SI PODEMOS COPIAR AL IZQUIERDO
			if( id == 'OdAdicion' ) {
				if(pValor !='') {
					if(this.objPedido.OiAdicion == '') {
						this.objPedido.OiAdicion = pValor;
					}
				}
			}

			// SI SE RECIBE ID LADO IZQUIERDO, VERIFICAMOS SI PODEMOS COPIAR AL DERECHO
			if (id == 'OiAdicion' ) {
				if( pValor != '' ) {
					
					if(this.objPedido.OdAdicion == ''){
						this.objPedido.OdAdicion = pValor;
					}
				}
			}
		},

		onClose(id,tipo) {
			switch (tipo) {
				case 'Esfera':	
					if(id == 'OdEsfera') { this.EsferaDerecha.showPopOver 	= false; }
					if(id == 'OiEsfera') { this.EsferaIzquierda.showPopOver = false; }
					
					break;

				case 'Cilindro':	
					if(id == 'OdCilindro') { this.CilindroDerecho.showPopOver 	= false; }
					if(id == 'OiCilindro') { this.CilindroIzquierdo.showPopOver 	= false; }
					
					break;

				case 'RangoAdicional':	
					if(id == 'OdAdicion') { this.RanAdicionalDerecho.showPopOver 	= false; }
					if(id == 'OiAdicion') { this.RanAdicionalIzquierdo.showPopOver 	= false; }
					
					break;

				case 'Eje':	
					if(id == 'OdEje') { this.RanAdicionalDerecho.showPopOver 	= false; }
					if(id == 'OiEje') { this.RanAdicionalIzquierdo.showPopOver 	= false; }
					
					break;
			}
		},

		onHidden() {
			/****** CONTROL DE ESFERAS ******/
			this.EsferaDerecha ={
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			this.EsferaIzquierda ={
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			/****** CONTROL DE CILINDROS ******/
			this.CilindroDerecho.showTool 		= false;
			this.CilindroDerecho.showPopOver 	= false;
			this.CilindroDerecho.listaMedidas 	= [];

			this.CilindroIzquierdo.showTool 	= false;
			this.CilindroIzquierdo.showPopOver 	= false;
			this.CilindroIzquierdo.listaMedidas = [];


			/****** CONTROL DE RANGOS ADICIONALES ******/
			this.RanAdicionalDerecho = {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},
			this.RanAdicionalIzquierdo = {
				showTool: false,
				showPopOver: false,
				listaMedidas: [],
			},

			console.log('Accion al cerrar el pophover');
		},


		/***************** SELECCION DE SUBLINEAS PARA LENTES PROGRESIVOS *****************/

		// OBTIENE POR API LOS ARTICULOS DE SUBLINEA
		getSublinea() {
			console.log('Obteniendo Sub-lineas');

			this.ListaSublineas = [];
			this.$http.get( '/oplentesublineas',{
				params:{
					IdTipoLente: this.TpLenteSelect.IdTipoLente,
				}
			} )
            .then( res => {
				this.ListaSublineas = res.data.data;

            }).catch( err => {
				console.log(err);
            });
		},


		/***************** SELECCION DE ARTICULOS WEB *****************/

		// OBTIENE POR API LOS ARTICULOS DE SUBLINEA
		getArticulosWeb( pRecovery = false) {
			console.log('Obteniendo Articulos Web');

			this.ListaArticulosWeb = [];
			let newRequest = {
					IdSubLinea: this.objPedido.IdSubLinea,
					TipoLente: this.TpLenteSelect,
					OdEsfera: this.objPedido.OdEsfera,
					OiEsfera: this.objPedido.OiEsfera,
					OdCilindro: this.objPedido.OdCilindro,
					OiCilindro: this.objPedido.OiCilindro,
					OdAdicion: this.objPedido.OdAdicion,
					OiAdicion: this.objPedido.OiAdicion,
			};

			this.$http.post('/opgetarticulosweb', newRequest)
            .then( res => {
				this.ListaArticulosWeb = res.data.data;

            }).catch( err => {
				console.log(err);
            }).finally(() => {
				this.getMateriales(pRecovery);
			});
		},

		// OBTIENE POR API LOS MATERIALES DE DISPONIBLES Y ESTABLECE GLOBAL EN EL FORM EL ARTICULO WEB SELECCIONADO
		getMateriales (pRecovery = false) {
			console.log('Obteniendo Materiales');
			// BUSCAMOS Y ESTABLECEMOS EL ARTICULO WEB DE MANERA GLOBAL EN EL FORM
			if(parseInt(this.objPedido.IdArticuloWeb) > 0) {
				let array = this.ListaArticulosWeb.filter(item => item.IdArticuloWeb == this.objPedido.IdArticuloWeb);

				if(array != undefined && array.length > 0) {
					this.articuloWebSelect = array[0];

					// SE VERIFICA QUE EL ARTICULO SELECCIONADO SI ESTA DISPONIBLE PARA CONTINUAR CON EL PROCESO. 
					if(this.articuloWebSelect.Seleccionable == 'NO') {
						this.bndBloqueoArticulo 			= true;
						this.toolTipRX.showPopArticulo 		= true;
						this.articuloWebSelect.ViewSeccion 	= false;

					}else {
						this.bndBloqueoArticulo 			= false;
						this.toolTipRX.showPopArticulo 		= false;

						if(this.articuloWebSelect.AnguloPantoscopico == 'SI' || this.articuloWebSelect.AnguloPanoramico == 'SI' || this.articuloWebSelect.DistanciaLectura == 'SI' || this.articuloWebSelect.DistanciaVertice == 'SI' || this.articuloWebSelect.Iniciales == 'SI' ){
							this.articuloWebSelect.ViewSeccion = true;
						}else {
							this.articuloWebSelect.ViewSeccion = false;
						}
					}

				}else {
					this.bndBloqueoArticulo 			= false;
					this.toolTipRX.showPopArticulo 		= false;
					this.articuloWebSelect.ViewSeccion 	= false;
				}


				// LLAMADO DE API
				this.ListaMateriales = [];
				let newRequest = {
					ArticuloWeb: this.articuloWebSelect,

					OdEsfera: this.objPedido.OdEsfera,
					OiEsfera: this.objPedido.OiEsfera,

					OdCilindro: this.objPedido.OdCilindro,
					OiCilindro: this.objPedido.OiCilindro,

					OdAdicion: this.objPedido.OdAdicion,
					OiAdicion: this.objPedido.OiAdicion,
				};

				this.$http.post('/opgetmateriales', newRequest)
				.then( res => {
					console.log(res.data);
					this.ListaMateriales = res.data.data;

				}).catch( err => {
					console.log(err);
				}).finally( () => {
					this.getValidMaterialSelected(pRecovery);
				})

			}else {
				this.bndBloqueoArticulo = false;
				this.articuloWebSelect.ViewSeccion = false;
			}

		},


		getValidMaterialSelected(pRecovery = false) {
			if(parseInt(this.objPedido.IdMaterial) > 0) {
				let array = this.ListaMateriales.filter(item => item.IdMaterial == this.objPedido.IdMaterial);

				if(array != undefined) {
					this.materialSelect = array[0];

					// SE VERIFICA QUE EL ARTICULO SELECCIONADO SI ESTA DISPONIBLE PARA CONTINUAR CON EL PROCESO. 
					if(this.materialSelect.Seleccionable == 'NO') {
						this.bndBloqueoMaterial			= true;
						this.toolTipRX.showPopMaterial 	= true;
						this.bndBloqueoProtxRecub		= true;

					}else {
						this.bndBloqueoMaterial 		= false;
						this.toolTipRX.showPopMaterial 	= false;
						this.bndBloqueoProtxRecub		= false;

						this.getProtecciones(pRecovery);
						this.getRecubrimientos(pRecovery);

					}

				}else {
					this.bndBloqueoProtxRecub			= true;
					this.bndBloqueoMaterial 			= false;
					this.toolTipRX.showPopMaterial 		= false;
				}

				
			}
		},

		// OBTIENE POR API LAS PROTECCIONES DISPONIBLES PARA EL ARTICULO WEB
		getProtecciones(pRecovery = false) {
			console.log('Obteniendo Protecciones');

			if(parseInt(this.objPedido.IdMaterial) > 0) {

				this.ListaProtecciones = [];
				let newRequest = {
						ArticuloWeb: this.articuloWebSelect,
						IdMaterial: this.objPedido.IdMaterial,

						OdEsfera: this.objPedido.OdEsfera,
						OiEsfera: this.objPedido.OiEsfera,
						OdCilindro: this.objPedido.OdCilindro,
						OiCilindro: this.objPedido.OiCilindro,
						OdAdicion: this.objPedido.OdAdicion,
						OiAdicion: this.objPedido.OiAdicion,
				};

				this.$http.post('/opgetprotecciones', newRequest)
				.then( res => {
					this.ListaProtecciones = res.data.data;

				}).catch( err => {
					console.log(err);
				}).finally( () => {
					if(pRecovery == false){
						this.calculaDioptrias();
					}

				});
			}
		},

		/***************** SECCION CALCULO DE DIOPTRIAS *****************/
		calculaDioptrias() {
			let newRequest = {
				//ArticuloWeb: this.articuloWebSelect,
				Procedimiento: 'Dioptria',
				IdMaterial: this.objPedido.IdMaterial,
				IdCliente: this.objCliente.IdCliente,

				OdEsfera: this.objPedido.OdEsfera,
				OiEsfera: this.objPedido.OiEsfera,
				OdCilindro: this.objPedido.OdCilindro,
				OiCilindro: this.objPedido.OiCilindro,
				//OdAdicion: this.objPedido.OdAdicion,
				//OiAdicion: this.objPedido.OiAdicion,
			};

			const result = this.detallePedido.filter((item) => item.TipoDet != 'Dioptria');
			this.detallePedido = result;
			this.$http.post('/opgetcostos', newRequest)
			.then( res => {
				if( res.data.data.length > 0) {
					this.detallePedido.push(res.data.data);
				}
				this.calculaCostos();

			}).catch( err => {
				console.log(err);
			}).finally(() => {
				
			})
		},

		/***************** SECCION CALCULO DE COSTO PROTECCIONES *****************/
		calculaCostosProtecciones() {
			let newRequest = {
				
				Procedimiento: 'Proteccion',
				ArticuloWeb: this.articuloWebSelect,
				TipoLente: this.TpLenteSelect,
				IdCliente: this.objCliente.IdCliente,
				IdMaterial: this.objPedido.IdMaterial,
				IdSubLinea: this.objPedido.IdSubLinea,
				IdProteccion:this.objPedido.IdProteccion,
				OjoDerecho: (this.objPedido.OjoDerecho == true) ? 'SI' : 'NO',
				OjoIzquierdo: (this.objPedido.OjoIzquierdo == true) ? 'SI' : 'NO',
				OdEsferaUnPar: 'NO',
				OiEsferaUnPar: 'NO',
			};

			const result = this.detallePedido.filter((item) => item.TipoDet != 'Proteccion');
			this.detallePedido = result;

			this.$http.post('/opgetcostos', newRequest)
			.then( res => {
				console.log(res.data);
				this.detallePedido.unshift(res.data.data);
				this.calculaCostos();

			}).catch( err => {
				console.log(err);
			}).finally(() => {
				
			})
		},


		// OBTIENE POR API LOS RECUBRIMIENTOS DISPONIBLES PARA EL ARTICULO WEB
		getRecubrimientos() {
			console.log('Obteniendo Recubrimientos');

			if(parseInt(this.objPedido.IdMaterial) > 0) {

				this.ListaRecubrimientos = [];
				let newRequest = {
					ArticuloWeb: this.articuloWebSelect,
				};

				this.$http.post('/opgetrecubrimientos', newRequest)
				.then( res => {
					this.ListaRecubrimientos = res.data.data;

				}).catch( err => {
					console.log(err);
				});
			}
		},

		/***************** SECCION CALCULO DE COSTO RECUBRIMIENTO *****************/
		calculaCostosRecubrimiento() {
			let newRequest = {
				
				Procedimiento: 'Recubrimiento',
				IdCliente: this.objCliente.IdCliente,
				IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if(parseInt(this.objPedido.IdMaterial) > 0 && parseInt(this.objPedido.IdRecubrimiento) > 0) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Recubrimiento');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				})
			}
		},

		
		
		/***************** SECCION DE MANEJO DE COSTOS *****************/
		calculaCostos() {
			let subtotal = 0;
			this.detallePedido.forEach((item) => {
				subtotal += parseFloat(item.Importe);
			});
			

			this.objPedido.SubTotal 	= subtotal;
			this.objPedido.Iva 			= (subtotal*0.16);
			this.objPedido.GranTotal 	= (subtotal + this.objPedido.Iva);
		},

		// OBTIENE POR API LOS ARMAZONES DISPONIBLES PARA EL ARTICULO WEB
		getArmazones() {
			console.log('Obteniendo Armazones');			

			this.ListaArmazones = [];

			this.$http.get('/opgetarmazon')
			.then( res => {
				this.ListaArmazones = res.data.data;

			}).catch( err => {
				console.log(err);
			});
			
		},


		
		// OBTIENE POR API LOS BISELES DISPONIBLES PARA EL ARTICULO WEB
		getBiseles() {
			console.log('Obteniendo Armazones');			

			this.ListaArmazones = [];

			this.$http.get('/opgetbiseles')
			.then( res => {
				this.ListaBiseles = res.data.data.map(item => 
				({
					IdBisel: item.IdBisel,
					Nombre: item.Nombre,
					Clave: item.Clave,
            		SubRegistro: item.SubRegistro,
            		ReqArmazon: item.ReqArmazon,
					Disponible: 'NO',
				})
			);

			}).catch( err => {
				console.log(err);
			});
			
		},

		getBiselesFilter(pTP = ''){
			return this.ListaBiseles.filter( item => item.ReqArmazon == pTP);
		},


		setBiselesActivos() {

			let pBisel =  this.ListaArmazones.filter( item => item.IdArmazon == this.objPedido.IdArmazon);
			console.log(pBisel);

			if (pBisel.length != null && pBisel.length > 0) { 
				this.ListaBiseles.forEach((item) => {

					if(item.IdBisel == pBisel[0].IdBisel){
						item.Disponible = 'SI';
						this.objPedido.IdBisel = item.IdBisel;
						this.calculaCostoBisel();
					}else {
						item.Disponible = 'NO';
					}
				});
			}

			// TODO: - VERIFICAR FUNCIONCIONALIDAD
			if( this.objPedido.EnviaArmazon == false) {

				// SI SE ENCONTRABA ACTIVO EL USO DE BISEL SENCILLO, SE LIMPIA IGUALMENTE EL ELEMENTO
				if( this.objPedido.UsaBiselSencillo == true ) {
					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;

					this.limpiarConfLente('biselsencillo');
				}

				// LIMPIAMOS DETALLE DE REGISTROS DE BISEL
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Bisel');
				this.detallePedido = result;

	
				this.calculaCostos();

				//LIMPIAMOS LOS CAMPOS CORRESPONDIENTES AL ARMAZON
				this.limpiarConfLente('armazon');

				if ( this.objPedido.NumPar == 1 ) {
					this.objPedido.CambioForma = false;
				}
			}
		},

		calculaCostoBisel() {
			let newRequest = {
				Procedimiento: 'Bisel',
				IdCliente: this.objCliente.IdCliente,
				IdBisel: this.objPedido.IdBisel,
			};

			if( this.objPedido.EnviaArmazon == true && this.objPedido.IdBisel > 0) {

				const result = this.detallePedido.filter((item) => item.TipoDet != 'Bisel');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				});

			}

		},

		calculaCostoBiselSencillo(pIdBiselSencillo) {
			
			if( this.objPedido.EnviaArmazon == true ) {

				if( this.objPedido.UsaBiselSencillo == true ) {

					this.objPedido.IdBiselSencillo = (pIdBiselSencillo != '' && pIdBiselSencillo > 0) ? pIdBiselSencillo : 0;

					let newRequest = {
						Procedimiento: 'BiselSencillo',
						IdCliente: this.objCliente.IdCliente,
						IdBiselSencillo: this.objPedido.IdBiselSencillo
					};

					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;

					this.$http.post('/opgetcostos', newRequest)
					.then( res => {
						console.log(res.data);
						this.detallePedido.push(res.data.data);
						this.calculaCostos();

					}).catch( err => {
						console.log(err);
					}).finally(() => {
						
					});

				}else {
					const result = this.detallePedido.filter((item) => item.TipoDet != 'BiselSencillo');
					this.detallePedido = result;
					this.calculaCostos();
				}

			}

		},

		calculaCostoForma() {
			let newRequest = {
				
				Procedimiento: 'CambioForma',
				IdCliente: this.objCliente.IdCliente,
				//IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if( this.objPedido.CambioForma == true ) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'CambioForma');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				});

			}else {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'CambioForma');
				this.detallePedido = result;

				this.objPedido.EscanearForma 	= '';
				this.objPedido.MontarArmazon 	= '';
				this.objPedido.AumentarMedida 	= 'NO';
				this.objPedido.AumentarArriba 	= '';
				this.objPedido.AumentaAbajo 	= '';
				this.objPedido.AumentaDerecho 	= '';
				this.objPedido.Contorno 		= '';

				this.calculaCostos();
			}
		},


		// OBTIENE POR API LOS BISELES DISPONIBLES PARA EL ARTICULO WEB
		getColoresTinte() {
			console.log('Obteniendo Tinte');			
			this.ListaColores = [];

			this.$http.get('/colores',{
				params:{
					EnPedido: 'SI'
				}
			})
			.then( res => {	
				this.ListaColores = res.data.data.data.map(item => 
					({
						IdColor: item.IdColor,
						Nombre: item.Nombre,
						Color: item.Color,
						EnPedido: item.EnPedido,
						EnLenteC: item.EnLenteC,
						Disponible: 'NO',
					})
				);
			}).catch( err => {
				console.log(err);
			});
			
		},

		calculaCostoEntintado() {
			let newRequest = {
				
				Procedimiento: 'Tinte',
				IdCliente: this.objCliente.IdCliente,
				//IdRecubrimiento: this.objPedido.IdRecubrimiento,
				
			};

			if( this.objPedido.ReqTinte == true ) {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Tinte');
				this.detallePedido = result;

				this.$http.post('/opgetcostos', newRequest)
				.then( res => {
					console.log(res.data);
					this.detallePedido.push(res.data.data);
					this.calculaCostos();

				}).catch( err => {
					console.log(err);
				}).finally(() => {
					
				});

			}else {
				const result = this.detallePedido.filter((item) => item.TipoDet != 'Tinte');
				this.detallePedido = result;

				this.calculaCostos();
			}
		},


    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

		let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        
        if(Origen != undefined && Origen != null && Origen != '' ) {
            
            this.oBtnSave.ReturnRoute = (Origen == 'Cotizaciones') ? 'cotizaciones' : 'pedidos';
			
        }
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.getListTiposLentes();
		this.getArmazones();
		this.getBiseles();
		this.getColoresTinte();

        if(this.Id !='' && this.Id != undefined && this.Id > 0) 
        {
            this.objPedido.IdPedido = this.Id;
            this.Recuperar();
			this.cambiarPaso(1);
        }
		else {	
		
			//this.ConfigList.Title = (this.oBtnSave.ReturnRoute  == 'cotizaciones') ? 'Crear Nueva Cotizacion' : 'Crear Nuevo Pedido';	
			this.cambiarPaso(1);		
			this.ConfigLoad.ShowLoader = false;
		}

		if(this.Obj != '' && this.Obj != undefined) {
			this.locationForm = this.Obj;
		}else {
			if (sessionStorage.getItem('menuOrigen') != '' && sessionStorage.getItem('menuOrigen') != undefined) {
				this.locationForm = JSON.parse(sessionStorage.getItem('menuOrigen'));
			}else {
				this.locationForm = 'Cotizaciones';
			}
		}

        this.bus.$on('Save_'+this.Emit,()=>
        {	
			console.log('Guardando de Emit...');
            this.Guardar('Pendiente');
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

    },

	computed: {
	
		
	
	}
}
</script>
<style>
.IzEsferas{
	left:80px !important;
}
.c-pop {
	right: 10px !important;
}

.popover-body {
    font-size: 13px !important;
}

.form-check:not(.form-switch) .form-check-input[type="radio"].lente:after {
  transition: opacity 0.25s ease-in-out;
  content: "";
  position: absolute;
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 50%;
  background-color: transparent !important;
  opacity: 0;
}

.form-check:not(.form-switch) .form-check-input[type="radio"].lente:checked {
	padding-top: 4.3px !important;
    padding-right: 5.3px !important;
    padding-bottom: 5.3px !important;
    padding-left: 6.8px !important;
}

input[type="radio"].lente{
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #394e64;
    -webkit-box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.75);
    cursor: pointer;
}

input[type="radio"].lente{
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}
input[type="radio"].lente:checked:after{
    font-family: "Font Awesome 5 Pro" !important;
  	content: "\f00c" !important;
	color: white !important;
    
}
input[type="radio"].lente:focus{
    outline: none;
}
.form-check-input:checked[type="radio"].lente {
    background-image: none;
}
.form-check-input:checked[type=radio].lente {
    --bs-form-check-bg-image:none;
}


</style>
